// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.13.0 (commit 08e1aba133671f9c631c6e70133a82faa0e7b283).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AbandonAdventureReducer from "./abandon_adventure_reducer";
import AbandonEncounterReducer from "./abandon_encounter_reducer";
import AcceptOfferReducer from "./accept_offer_reducer";
import AcceptSurrenderReducer from "./accept_surrender_reducer";
import AcceptTradeReducer from "./accept_trade_reducer";
import AcceptUpgradeGiftReducer from "./accept_upgrade_gift_reducer";
import AdminAuditNoteReducer from "./admin_audit_note_reducer";
import AdminFailJobReducer from "./admin_fail_job_reducer";
import AdminRequeueJobReducer from "./admin_requeue_job_reducer";
import AdminUnmakeShelfWorldReducer from "./admin_unmake_shelf_world_reducer";
import AnswerBandCallReducer from "./answer_band_call_reducer";
import AssumeControlReducer from "./assume_control_reducer";
import BeginWorldReducer from "./begin_world_reducer";
import BuyBoostReducer from "./buy_boost_reducer";
import BuyHintReducer from "./buy_hint_reducer";
import BuyMarketPieceReducer from "./buy_market_piece_reducer";
import BuyPackReducer from "./buy_pack_reducer";
import BuySecretReducer from "./buy_secret_reducer";
import BuyStockReducer from "./buy_stock_reducer";
import BuyTradeReducer from "./buy_trade_reducer";
import CallFleeReducer from "./call_flee_reducer";
import CancelFleeReducer from "./cancel_flee_reducer";
import CancelTradeReducer from "./cancel_trade_reducer";
import ChooseColourReducer from "./choose_colour_reducer";
import ChooseLevelUpReducer from "./choose_level_up_reducer";
import ChooseWonderBlessingReducer from "./choose_wonder_blessing_reducer";
import ClaimJobReducer from "./claim_job_reducer";
import ClaimPileReducer from "./claim_pile_reducer";
import ClaimUsernameReducer from "./claim_username_reducer";
import ClearSpentInputsReducer from "./clear_spent_inputs_reducer";
import CommitHeroReducer from "./commit_hero_reducer";
import CreateHeroReducer from "./create_hero_reducer";
import CreatePartyReducer from "./create_party_reducer";
import CreateWorldReducer from "./create_world_reducer";
import DeclineTradeReducer from "./decline_trade_reducer";
import DeclineUpgradeGiftReducer from "./decline_upgrade_gift_reducer";
import DeliverCampaignQuestReducer from "./deliver_campaign_quest_reducer";
import DeliverChapterSceneReducer from "./deliver_chapter_scene_reducer";
import DeliverChronicleVoiceReducer from "./deliver_chronicle_voice_reducer";
import DeliverGenerationReducer from "./deliver_generation_reducer";
import DeliverQuestEndingsReducer from "./deliver_quest_endings_reducer";
import DeliverRelicNameReducer from "./deliver_relic_name_reducer";
import DeliverSideQuestsReducer from "./deliver_side_quests_reducer";
import DeliverVillageReducer from "./deliver_village_reducer";
import DeliverVillageTalkReducer from "./deliver_village_talk_reducer";
import DeliverWorldGenesisReducer from "./deliver_world_genesis_reducer";
import DevBesideFindReducer from "./dev_beside_find_reducer";
import DevBesideSnareReducer from "./dev_beside_snare_reducer";
import DevBesideWonderReducer from "./dev_beside_wonder_reducer";
import DevClearFoesReducer from "./dev_clear_foes_reducer";
import DevCloseChapterReducer from "./dev_close_chapter_reducer";
import DevEndEncounterReducer from "./dev_end_encounter_reducer";
import DevGrantGoldReducer from "./dev_grant_gold_reducer";
import DevGrantItemReducer from "./dev_grant_item_reducer";
import DevGrantUpgradeGiftReducer from "./dev_grant_upgrade_gift_reducer";
import DevGrantXpReducer from "./dev_grant_xp_reducer";
import DevNameFoeReducer from "./dev_name_foe_reducer";
import DevOfferWonderBlessingReducer from "./dev_offer_wonder_blessing_reducer";
import DevOpenStashesReducer from "./dev_open_stashes_reducer";
import DevOpenWorkshopReducer from "./dev_open_workshop_reducer";
import DevPlaceMatterReducer from "./dev_place_matter_reducer";
import DevPlantSecretsReducer from "./dev_plant_secrets_reducer";
import DevSecureEncounterReducer from "./dev_secure_encounter_reducer";
import DevSetFogReducer from "./dev_set_fog_reducer";
import DevSetHostReducer from "./dev_set_host_reducer";
import DevSetHpReducer from "./dev_set_hp_reducer";
import DevSetSceneReducer from "./dev_set_scene_reducer";
import DevSetSizeReducer from "./dev_set_size_reducer";
import DevSetSkyReducer from "./dev_set_sky_reducer";
import DevSettleAdventureReducer from "./dev_settle_adventure_reducer";
import DevSpringTroubleReducer from "./dev_spring_trouble_reducer";
import DiceHoldReducer from "./dice_hold_reducer";
import DiceSitReducer from "./dice_sit_reducer";
import DiceStandReducer from "./dice_stand_reducer";
import DiceStartReducer from "./dice_start_reducer";
import DiceThrowReducer from "./dice_throw_reducer";
import DiceTickReducer from "./dice_tick_reducer";
import DiscardItemReducer from "./discard_item_reducer";
import DismissHeroReducer from "./dismiss_hero_reducer";
import DyeItemReducer from "./dye_item_reducer";
import EndBandCallReducer from "./end_band_call_reducer";
import EnqueueGenerationReducer from "./enqueue_generation_reducer";
import EnsureVillagesReducer from "./ensure_villages_reducer";
import EnterVillageReducer from "./enter_village_reducer";
import EquipReducer from "./equip_reducer";
import EquipToReducer from "./equip_to_reducer";
import FailJobReducer from "./fail_job_reducer";
import FinishEncounterReducer from "./finish_encounter_reducer";
import FinishMealReducer from "./finish_meal_reducer";
import FinishOutfittingReducer from "./finish_outfitting_reducer";
import ForceDoorReducer from "./force_door_reducer";
import ForgeHeroReducer from "./forge_hero_reducer";
import ForgeHeroCalledReducer from "./forge_hero_called_reducer";
import ForgeHeroVoicedReducer from "./forge_hero_voiced_reducer";
import GiveItemReducer from "./give_item_reducer";
import GoSoloReducer from "./go_solo_reducer";
import GrantModuleAdminReducer from "./grant_module_admin_reducer";
import HeartbeatReducer from "./heartbeat_reducer";
import HireVillagerReducer from "./hire_villager_reducer";
import InnToastReducer from "./inn_toast_reducer";
import InviteToWorldReducer from "./invite_to_world_reducer";
import JoinBandReducer from "./join_band_reducer";
import JoinOpeningReducer from "./join_opening_reducer";
import JoinPartyReducer from "./join_party_reducer";
import JoinWorldReducer from "./join_world_reducer";
import KickFromWorldReducer from "./kick_from_world_reducer";
import LearnTalentReducer from "./learn_talent_reducer";
import LeavePartyReducer from "./leave_party_reducer";
import LeaveVillageReducer from "./leave_village_reducer";
import LeaveWorldLobbyReducer from "./leave_world_lobby_reducer";
import LockRewardsReducer from "./lock_rewards_reducer";
import MusterReducer from "./muster_reducer";
import OfferTradeReducer from "./offer_trade_reducer";
import OpenWorldLobbyReducer from "./open_world_lobby_reducer";
import OpeningReadReducer from "./opening_read_reducer";
import OpeningReadyReducer from "./opening_ready_reducer";
import OrderDrinkReducer from "./order_drink_reducer";
import OrderMealReducer from "./order_meal_reducer";
import PauseReducer from "./pause_reducer";
import PickProgressReducer from "./pick_progress_reducer";
import PinNoticeReducer from "./pin_notice_reducer";
import PingBoardReducer from "./ping_board_reducer";
import PingQuestReducer from "./ping_quest_reducer";
import PingWorldReducer from "./ping_world_reducer";
import PlanRouteReducer from "./plan_route_reducer";
import ReadyReducer from "./ready_reducer";
import RedyeHeroReducer from "./redye_hero_reducer";
import ReforgeHeroReducer from "./reforge_hero_reducer";
import RefreshOffersReducer from "./refresh_offers_reducer";
import RefuseSurrenderReducer from "./refuse_surrender_reducer";
import RegisterServiceIdentityReducer from "./register_service_identity_reducer";
import ReleaseControlReducer from "./release_control_reducer";
import ReleasePileReducer from "./release_pile_reducer";
import RemoveFriendReducer from "./remove_friend_reducer";
import RemoveServiceIdentityReducer from "./remove_service_identity_reducer";
import RenameHeroReducer from "./rename_hero_reducer";
import RenameLobbyReducer from "./rename_lobby_reducer";
import RentRoomReducer from "./rent_room_reducer";
import RequestSongReducer from "./request_song_reducer";
import RespondFriendRequestReducer from "./respond_friend_request_reducer";
import RespondWorldInviteReducer from "./respond_world_invite_reducer";
import RestyleHeroReducer from "./restyle_hero_reducer";
import ResumeReducer from "./resume_reducer";
import RetireHeroReducer from "./retire_hero_reducer";
import RetrainHeroReducer from "./retrain_hero_reducer";
import RetryStoryReducer from "./retry_story_reducer";
import ReturnBoostReducer from "./return_boost_reducer";
import RevokeModuleAdminReducer from "./revoke_module_admin_reducer";
import SeeCollectedReducer from "./see_collected_reducer";
import SellItemReducer from "./sell_item_reducer";
import SendEmoteReducer from "./send_emote_reducer";
import SendFriendRequestReducer from "./send_friend_request_reducer";
import SendPartyMessageReducer from "./send_party_message_reducer";
import SendWorldMessageReducer from "./send_world_message_reducer";
import SetAllowPausingReducer from "./set_allow_pausing_reducer";
import SetAllowUncensoredReducer from "./set_allow_uncensored_reducer";
import SetDeadlineReducer from "./set_deadline_reducer";
import SetDisplayNameReducer from "./set_display_name_reducer";
import SetGearPlanReducer from "./set_gear_plan_reducer";
import SetHeroVoiceReducer from "./set_hero_voice_reducer";
import SetKillStreaksReducer from "./set_kill_streaks_reducer";
import SetLobbyReadyReducer from "./set_lobby_ready_reducer";
import SetLobbyStorytellerReducer from "./set_lobby_storyteller_reducer";
import SetPartyWindowReducer from "./set_party_window_reducer";
import ShareMomentReducer from "./share_moment_reducer";
import SignGuestbookReducer from "./sign_guestbook_reducer";
import StandRoundReducer from "./stand_round_reducer";
import StartEncounterReducer from "./start_encounter_reducer";
import SubmitIntentReducer from "./submit_intent_reducer";
import TakeLevelReducer from "./take_level_reducer";
import TakeUpOfferReducer from "./take_up_offer_reducer";
import TrainHeroReducer from "./train_hero_reducer";
import TransferControlReducer from "./transfer_control_reducer";
import TravelToSiteReducer from "./travel_to_site_reducer";
import UncommitHeroReducer from "./uncommit_hero_reducer";
import UnequipReducer from "./unequip_reducer";
import UnfinishEncounterReducer from "./unfinish_encounter_reducer";
import UnlockRewardsReducer from "./unlock_rewards_reducer";
import UnpinNoticeReducer from "./unpin_notice_reducer";
import UnreadyReducer from "./unready_reducer";
import UpdateWorldSettingsReducer from "./update_world_settings_reducer";
import UpgradeItemReducer from "./upgrade_item_reducer";
import UseItemInCampReducer from "./use_item_in_camp_reducer";
import VillageGoReducer from "./village_go_reducer";
import VillageMoveReducer from "./village_move_reducer";
import VillageSitReducer from "./village_sit_reducer";
import VillageStandReducer from "./village_stand_reducer";
import WalkBandReducer from "./walk_band_reducer";
import WithdrawIntentReducer from "./withdraw_intent_reducer";
import WorkerHeartbeatReducer from "./worker_heartbeat_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AdventureInstanceRow from "./adventure_instance_table";
import BandCallRow from "./band_call_table";
import BoardPingRow from "./board_ping_table";
import BookChapterRow from "./book_chapter_table";
import CampaignProgressRow from "./campaign_progress_table";
import ChronicleEventRow from "./chronicle_event_table";
import ChronicleVoiceRow from "./chronicle_voice_table";
import ClientCompatRow from "./client_compat_table";
import ControlGrantRow from "./control_grant_table";
import CrawlForceRow from "./crawl_force_table";
import DiceTableRow from "./dice_table_table";
import EncounterRow from "./encounter_table";
import EncounterBoonRow from "./encounter_boon_table";
import EncounterHaulRow from "./encounter_haul_table";
import EncounterResultRow from "./encounter_result_table";
import EncounterSecuredRow from "./encounter_secured_table";
import EncounterStageRow from "./encounter_stage_table";
import FinishVoteRow from "./finish_vote_table";
import FoeFateRow from "./foe_fate_table";
import FoundingKitRow from "./founding_kit_table";
import FoundingMarketRow from "./founding_market_table";
import FoundingOutfitRow from "./founding_outfit_table";
import FoundingPurseRow from "./founding_purse_table";
import FrozenInstanceRow from "./frozen_instance_table";
import GearPlanRow from "./gear_plan_table";
import GenerationJobRow from "./generation_job_table";
import HaulGoldRow from "./haul_gold_table";
import HaulItemRow from "./haul_item_table";
import HeroRow from "./hero_table";
import HeroBoonRow from "./hero_boon_table";
import HeroCallingRow from "./hero_calling_table";
import HeroDyeRow from "./hero_dye_table";
import HeroEmoteRow from "./hero_emote_table";
import HeroMealRow from "./hero_meal_table";
import HeroOriginRow from "./hero_origin_table";
import HeroPackRow from "./hero_pack_table";
import HeroProgressRow from "./hero_progress_table";
import HeroRouteRow from "./hero_route_table";
import HeroVoiceRow from "./hero_voice_table";
import InnCheerRow from "./inn_cheer_table";
import InnGuestbookRow from "./inn_guestbook_table";
import InnNoticeRow from "./inn_notice_table";
import InnRentRow from "./inn_rent_table";
import InnSongRow from "./inn_song_table";
import InnVisitRow from "./inn_visit_table";
import IntentRow from "./intent_table";
import ItemRow from "./item_table";
import ItemDyeRow from "./item_dye_table";
import ItemUpgradeRow from "./item_upgrade_table";
import LevelUpOfferRow from "./level_up_offer_table";
import LobbySeatRow from "./lobby_seat_table";
import LocationStatusRow from "./location_status_table";
import LootDrawRow from "./loot_draw_table";
import MyAccountRow from "./my_account_table";
import MyCollectedPiecesRow from "./my_collected_pieces_table";
import MyFriendshipsRow from "./my_friendships_table";
import MyHeroesRow from "./my_heroes_table";
import MyInventoryRow from "./my_inventory_table";
import MyLevelUpOffersRow from "./my_level_up_offers_table";
import MyPlayerSettingRow from "./my_player_setting_table";
import MyTradesRow from "./my_trades_table";
import MyVillageKnownRow from "./my_village_known_table";
import MyWorldInvitesRow from "./my_world_invites_table";
import MyWorldMessagesRow from "./my_world_messages_table";
import NamedCharacterRow from "./named_character_table";
import OfferRow from "./offer_table";
import PartyRow from "./party_table";
import PartyMemberRow from "./party_member_table";
import PartyMessageRow from "./party_message_table";
import PartyWalkRow from "./party_walk_table";
import PauseStateRow from "./pause_state_table";
import PlayerColourRow from "./player_colour_table";
import PlayerProfileRow from "./player_profile_table";
import PulseRow from "./pulse_table";
import PuzzleNoteRow from "./puzzle_note_table";
import PuzzleRoomRow from "./puzzle_room_table";
import QuestPingRow from "./quest_ping_table";
import QuestStageRow from "./quest_stage_table";
import QuestWoundRow from "./quest_wound_table";
import ReadyStateRow from "./ready_state_table";
import RegardRowRow from "./regard_row_table";
import RelicNameRow from "./relic_name_table";
import ResolutionLogRow from "./resolution_log_table";
import RewardDivisionRow from "./reward_division_table";
import RewardLockRow from "./reward_lock_table";
import RewardPileRow from "./reward_pile_table";
import ServiceIdentityRow from "./service_identity_table";
import SettlementRow from "./settlement_table";
import SfxScoreRow from "./sfx_score_table";
import ShelfWorldRow from "./shelf_world_table";
import SpoilsSkimRow from "./spoils_skim_table";
import UpgradeGiftRow from "./upgrade_gift_table";
import VillageRow from "./village_table";
import VillageFiguresRow from "./village_figures_table";
import VillageMomentRow from "./village_moment_table";
import VillageNpcRow from "./village_npc_table";
import VillagePresenceRow from "./village_presence_table";
import VillageSeatRow from "./village_seat_table";
import VillageStockRow from "./village_stock_table";
import VillageWorkshopRow from "./village_workshop_table";
import WildlifeRow from "./wildlife_table";
import WonderBlessingRow from "./wonder_blessing_table";
import WorldRow from "./world_table";
import WorldClockRow from "./world_clock_table";
import WorldMemberRow from "./world_member_table";
import WorldOpeningRow from "./world_opening_table";
import WorldPingRow from "./world_ping_table";
import WorldPresenceRow from "./world_presence_table";
import WorldSettingsRow from "./world_settings_table";
import WorldStoryRow from "./world_story_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  adventureInstance: __table({
    name: 'adventure_instance',
    indexes: [
      { accessor: 'id', name: 'adventure_instance_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'party_id', name: 'adventure_instance_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
      { accessor: 'world_id', name: 'adventure_instance_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'adventure_instance_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AdventureInstanceRow),
  bandCall: __table({
    name: 'band_call',
    indexes: [
      { accessor: 'id', name: 'band_call_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'band_call_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'band_call_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, BandCallRow),
  boardPing: __table({
    name: 'board_ping',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, BoardPingRow),
  bookChapter: __table({
    name: 'book_chapter',
    indexes: [
      { accessor: 'id', name: 'book_chapter_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'book_chapter_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'book_chapter_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, BookChapterRow),
  campaignProgress: __table({
    name: 'campaign_progress',
    indexes: [
      { accessor: 'world_id', name: 'campaign_progress_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'campaign_progress_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, CampaignProgressRow),
  chronicleEvent: __table({
    name: 'chronicle_event',
    indexes: [
      { accessor: 'id', name: 'chronicle_event_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'chronicle_event_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'by_world_seq', name: 'chronicle_event_world_id_seq_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'seq',
      ] },
    ],
    constraints: [
      { name: 'chronicle_event_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ChronicleEventRow),
  chronicleVoice: __table({
    name: 'chronicle_voice',
    indexes: [
      { accessor: 'event_id', name: 'chronicle_voice_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'world_id', name: 'chronicle_voice_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'chronicle_voice_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, ChronicleVoiceRow),
  clientCompat: __table({
    name: 'client_compat',
    indexes: [
      { accessor: 'id', name: 'client_compat_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'client_compat_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ClientCompatRow),
  controlGrant: __table({
    name: 'control_grant',
    indexes: [
      { accessor: 'by_hero', name: 'control_grant_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'id', name: 'control_grant_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'control_grant_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ControlGrantRow),
  crawlForce: __table({
    name: 'crawl_force',
    indexes: [
      { accessor: 'encounter_id', name: 'crawl_force_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'world_id', name: 'crawl_force_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'crawl_force_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, CrawlForceRow),
  diceTable: __table({
    name: 'dice_table',
    indexes: [
      { accessor: 'village_id', name: 'dice_table_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'dice_table_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'dice_table_village_id_key', constraint: 'unique', columns: ['villageId'] },
    ],
  }, DiceTableRow),
  encounter: __table({
    name: 'encounter',
    indexes: [
      { accessor: 'id', name: 'encounter_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'party_id', name: 'encounter_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
      { accessor: 'world_id', name: 'encounter_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'encounter_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, EncounterRow),
  encounterBoon: __table({
    name: 'encounter_boon',
    indexes: [
      { accessor: 'by_encounter', name: 'encounter_boon_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'encounter_boon_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'encounter_boon_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, EncounterBoonRow),
  encounterHaul: __table({
    name: 'encounter_haul',
    indexes: [
      { accessor: 'encounter_id', name: 'encounter_haul_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'world_id', name: 'encounter_haul_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'encounter_haul_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, EncounterHaulRow),
  encounterResult: __table({
    name: 'encounter_result',
    indexes: [
      { accessor: 'by_encounter', name: 'encounter_result_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'encounter_result_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'encounter_result_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, EncounterResultRow),
  encounterSecured: __table({
    name: 'encounter_secured',
    indexes: [
      { accessor: 'encounter_id', name: 'encounter_secured_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'world_id', name: 'encounter_secured_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'encounter_secured_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, EncounterSecuredRow),
  encounterStage: __table({
    name: 'encounter_stage',
    indexes: [
      { accessor: 'encounter_id', name: 'encounter_stage_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'world_id', name: 'encounter_stage_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'encounter_stage_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, EncounterStageRow),
  finishVote: __table({
    name: 'finish_vote',
    indexes: [
      { accessor: 'by_encounter', name: 'finish_vote_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'finish_vote_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'finish_vote_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FinishVoteRow),
  foeFate: __table({
    name: 'foe_fate',
    indexes: [
      { accessor: 'encounter_id', name: 'foe_fate_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'by_world', name: 'foe_fate_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'foe_fate_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, FoeFateRow),
  foundingKit: __table({
    name: 'founding_kit',
    indexes: [
      { accessor: 'hero_id', name: 'founding_kit_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'item_id', name: 'founding_kit_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'world_id', name: 'founding_kit_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'founding_kit_item_id_key', constraint: 'unique', columns: ['itemId'] },
    ],
  }, FoundingKitRow),
  foundingMarket: __table({
    name: 'founding_market',
    indexes: [
      { accessor: 'id', name: 'founding_market_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'founding_market_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'founding_market_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FoundingMarketRow),
  foundingOutfit: __table({
    name: 'founding_outfit',
    indexes: [
      { accessor: 'hero_id', name: 'founding_outfit_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'world_id', name: 'founding_outfit_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'founding_outfit_hero_id_key', constraint: 'unique', columns: ['heroId'] },
    ],
  }, FoundingOutfitRow),
  foundingPurse: __table({
    name: 'founding_purse',
    indexes: [
      { accessor: 'id', name: 'founding_purse_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'founding_purse_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'by_world_owner', name: 'founding_purse_world_id_owner_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'owner',
      ] },
    ],
    constraints: [
      { name: 'founding_purse_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FoundingPurseRow),
  frozenInstance: __table({
    name: 'frozen_instance',
    indexes: [
      { accessor: 'id', name: 'frozen_instance_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_world_kind', name: 'frozen_instance_world_id_kind_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'kind',
      ] },
    ],
    constraints: [
      { name: 'frozen_instance_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FrozenInstanceRow),
  gearPlan: __table({
    name: 'gear_plan',
    indexes: [
      { accessor: 'by_encounter', name: 'gear_plan_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'gear_plan_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'gear_plan_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GearPlanRow),
  generationJob: __table({
    name: 'generation_job',
    indexes: [
      { accessor: 'id', name: 'generation_job_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_status', name: 'generation_job_status_idx_btree', algorithm: 'btree', columns: [
        'status',
      ] },
      { accessor: 'world_id', name: 'generation_job_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'generation_job_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GenerationJobRow),
  haulGold: __table({
    name: 'haul_gold',
    indexes: [
      { accessor: 'by_encounter', name: 'haul_gold_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'haul_gold_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'haul_gold_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'haul_gold_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, HaulGoldRow),
  haulItem: __table({
    name: 'haul_item',
    indexes: [
      { accessor: 'by_encounter', name: 'haul_item_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'haul_item_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'haul_item_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, HaulItemRow),
  hero: __table({
    name: 'hero',
    indexes: [
      { accessor: 'id', name: 'hero_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'hero_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'world_id', name: 'hero_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'by_world_owner', name: 'hero_world_id_owner_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'owner',
      ] },
    ],
    constraints: [
      { name: 'hero_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, HeroRow),
  heroBoon: __table({
    name: 'hero_boon',
    indexes: [
      { accessor: 'by_hero', name: 'hero_boon_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'id', name: 'hero_boon_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'hero_boon_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'world_id', name: 'hero_boon_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'hero_boon_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, HeroBoonRow),
  heroCalling: __table({
    name: 'hero_calling',
    indexes: [
      { accessor: 'hero_id', name: 'hero_calling_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'world_id', name: 'hero_calling_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'hero_calling_hero_id_key', constraint: 'unique', columns: ['heroId'] },
    ],
  }, HeroCallingRow),
  heroDye: __table({
    name: 'hero_dye',
    indexes: [
      { accessor: 'hero_id', name: 'hero_dye_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'world_id', name: 'hero_dye_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'hero_dye_hero_id_key', constraint: 'unique', columns: ['heroId'] },
    ],
  }, HeroDyeRow),
  heroEmote: __table({
    name: 'hero_emote',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, HeroEmoteRow),
  heroMeal: __table({
    name: 'hero_meal',
    indexes: [
      { accessor: 'hero_id', name: 'hero_meal_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'owner', name: 'hero_meal_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'world_id', name: 'hero_meal_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'hero_meal_hero_id_key', constraint: 'unique', columns: ['heroId'] },
    ],
  }, HeroMealRow),
  heroOrigin: __table({
    name: 'hero_origin',
    indexes: [
      { accessor: 'hero_id', name: 'hero_origin_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'world_id', name: 'hero_origin_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'hero_origin_hero_id_key', constraint: 'unique', columns: ['heroId'] },
    ],
  }, HeroOriginRow),
  heroPack: __table({
    name: 'hero_pack',
    indexes: [
      { accessor: 'hero_id', name: 'hero_pack_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'world_id', name: 'hero_pack_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'hero_pack_hero_id_key', constraint: 'unique', columns: ['heroId'] },
    ],
  }, HeroPackRow),
  heroProgress: __table({
    name: 'hero_progress',
    indexes: [
      { accessor: 'hero_id', name: 'hero_progress_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'world_id', name: 'hero_progress_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'hero_progress_hero_id_key', constraint: 'unique', columns: ['heroId'] },
    ],
  }, HeroProgressRow),
  heroRoute: __table({
    name: 'hero_route',
    indexes: [
      { accessor: 'by_encounter', name: 'hero_route_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'hero_route_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'hero_route_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, HeroRouteRow),
  heroVoice: __table({
    name: 'hero_voice',
    indexes: [
      { accessor: 'hero_id', name: 'hero_voice_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'world_id', name: 'hero_voice_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'hero_voice_hero_id_key', constraint: 'unique', columns: ['heroId'] },
    ],
  }, HeroVoiceRow),
  innCheer: __table({
    name: 'inn_cheer',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, InnCheerRow),
  innGuestbook: __table({
    name: 'inn_guestbook',
    indexes: [
      { accessor: 'id', name: 'inn_guestbook_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'village_id', name: 'inn_guestbook_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'inn_guestbook_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'inn_guestbook_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, InnGuestbookRow),
  innNotice: __table({
    name: 'inn_notice',
    indexes: [
      { accessor: 'id', name: 'inn_notice_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'village_id', name: 'inn_notice_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'inn_notice_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'inn_notice_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, InnNoticeRow),
  innRent: __table({
    name: 'inn_rent',
    indexes: [
      { accessor: 'id', name: 'inn_rent_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'inn_rent_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'world_id', name: 'inn_rent_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'inn_rent_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, InnRentRow),
  innSong: __table({
    name: 'inn_song',
    indexes: [
      { accessor: 'village_id', name: 'inn_song_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'inn_song_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'inn_song_village_id_key', constraint: 'unique', columns: ['villageId'] },
    ],
  }, InnSongRow),
  innVisit: __table({
    name: 'inn_visit',
    indexes: [
      { accessor: 'village_id', name: 'inn_visit_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'inn_visit_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'inn_visit_village_id_key', constraint: 'unique', columns: ['villageId'] },
    ],
  }, InnVisitRow),
  intent: __table({
    name: 'intent',
    indexes: [
      { accessor: 'by_enc_hero_slot', name: 'intent_encounter_id_hero_id_slot_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
        'heroId',
        'slot',
      ] },
      { accessor: 'by_encounter', name: 'intent_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'intent_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'intent_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, IntentRow),
  item: __table({
    name: 'item',
    indexes: [
      { accessor: 'by_hero', name: 'item_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'id', name: 'item_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'item_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'item_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ItemRow),
  itemDye: __table({
    name: 'item_dye',
    indexes: [
      { accessor: 'item_id', name: 'item_dye_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'world_id', name: 'item_dye_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'item_dye_item_id_key', constraint: 'unique', columns: ['itemId'] },
    ],
  }, ItemDyeRow),
  itemUpgrade: __table({
    name: 'item_upgrade',
    indexes: [
      { accessor: 'item_id', name: 'item_upgrade_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'world_id', name: 'item_upgrade_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'item_upgrade_item_id_key', constraint: 'unique', columns: ['itemId'] },
    ],
  }, ItemUpgradeRow),
  levelUpOffer: __table({
    name: 'level_up_offer',
    indexes: [
      { accessor: 'by_hero', name: 'level_up_offer_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'id', name: 'level_up_offer_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'level_up_offer_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'level_up_offer_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LevelUpOfferRow),
  lobbySeat: __table({
    name: 'lobby_seat',
    indexes: [
      { accessor: 'id', name: 'lobby_seat_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'lobby_seat_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'by_world_owner', name: 'lobby_seat_world_id_owner_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'owner',
      ] },
    ],
    constraints: [
      { name: 'lobby_seat_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LobbySeatRow),
  locationStatus: __table({
    name: 'location_status',
    indexes: [
      { accessor: 'id', name: 'location_status_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_world_index', name: 'location_status_world_id_location_index_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'locationIndex',
      ] },
    ],
    constraints: [
      { name: 'location_status_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LocationStatusRow),
  lootDraw: __table({
    name: 'loot_draw',
    indexes: [
      { accessor: 'id', name: 'loot_draw_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_instance', name: 'loot_draw_instance_id_idx_btree', algorithm: 'btree', columns: [
        'instanceId',
      ] },
    ],
    constraints: [
      { name: 'loot_draw_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LootDrawRow),
  namedCharacter: __table({
    name: 'named_character',
    indexes: [
      { accessor: 'id', name: 'named_character_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_world_npc', name: 'named_character_world_id_npc_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'npc',
      ] },
    ],
    constraints: [
      { name: 'named_character_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, NamedCharacterRow),
  offer: __table({
    name: 'offer',
    indexes: [
      { accessor: 'id', name: 'offer_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'offer_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'offer_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, OfferRow),
  party: __table({
    name: 'party',
    indexes: [
      { accessor: 'id', name: 'party_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'party_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'party_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PartyRow),
  partyMember: __table({
    name: 'party_member',
    indexes: [
      { accessor: 'by_hero', name: 'party_member_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'id', name: 'party_member_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_party', name: 'party_member_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'party_member_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PartyMemberRow),
  partyMessage: __table({
    name: 'party_message',
    indexes: [
      { accessor: 'id', name: 'party_message_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_party', name: 'party_message_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'party_message_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PartyMessageRow),
  partyWalk: __table({
    name: 'party_walk',
    indexes: [
      { accessor: 'party_id', name: 'party_walk_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
      { accessor: 'world_id', name: 'party_walk_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'party_walk_party_id_key', constraint: 'unique', columns: ['partyId'] },
    ],
  }, PartyWalkRow),
  pauseState: __table({
    name: 'pause_state',
    indexes: [
      { accessor: 'encounter_id', name: 'pause_state_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
    ],
    constraints: [
      { name: 'pause_state_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, PauseStateRow),
  playerColour: __table({
    name: 'player_colour',
    indexes: [
      { accessor: 'id', name: 'player_colour_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'player_colour_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'by_world_owner', name: 'player_colour_world_id_owner_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'owner',
      ] },
    ],
    constraints: [
      { name: 'player_colour_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PlayerColourRow),
  playerProfile: __table({
    name: 'player_profile',
    indexes: [
      { accessor: 'identity', name: 'player_profile_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'username', name: 'player_profile_username_idx_btree', algorithm: 'btree', columns: [
        'username',
      ] },
    ],
    constraints: [
      { name: 'player_profile_identity_key', constraint: 'unique', columns: ['identity'] },
      { name: 'player_profile_username_key', constraint: 'unique', columns: ['username'] },
    ],
  }, PlayerProfileRow),
  pulse: __table({
    name: 'pulse',
    indexes: [
      { accessor: 'by_encounter', name: 'pulse_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'pulse_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'pulse_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PulseRow),
  puzzleNote: __table({
    name: 'puzzle_note',
    indexes: [
      { accessor: 'encounter_id', name: 'puzzle_note_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'puzzle_note_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'puzzle_note_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PuzzleNoteRow),
  puzzleRoom: __table({
    name: 'puzzle_room',
    indexes: [
      { accessor: 'encounter_id', name: 'puzzle_room_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'world_id', name: 'puzzle_room_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'puzzle_room_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, PuzzleRoomRow),
  questPing: __table({
    name: 'quest_ping',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, QuestPingRow),
  questStage: __table({
    name: 'quest_stage',
    indexes: [
      { accessor: 'offer_id', name: 'quest_stage_offer_id_idx_btree', algorithm: 'btree', columns: [
        'offerId',
      ] },
      { accessor: 'world_id', name: 'quest_stage_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'quest_stage_offer_id_key', constraint: 'unique', columns: ['offerId'] },
    ],
  }, QuestStageRow),
  questWound: __table({
    name: 'quest_wound',
    indexes: [
      { accessor: 'id', name: 'quest_wound_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_instance', name: 'quest_wound_instance_id_idx_btree', algorithm: 'btree', columns: [
        'instanceId',
      ] },
      { accessor: 'world_id', name: 'quest_wound_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'quest_wound_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, QuestWoundRow),
  readyState: __table({
    name: 'ready_state',
    indexes: [
      { accessor: 'by_encounter', name: 'ready_state_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'ready_state_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'ready_state_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ReadyStateRow),
  regardRow: __table({
    name: 'regard_row',
    indexes: [
      { accessor: 'id', name: 'regard_row_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'by_world_npc', name: 'regard_row_world_id_npc_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'npc',
      ] },
    ],
    constraints: [
      { name: 'regard_row_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RegardRowRow),
  relicName: __table({
    name: 'relic_name',
    indexes: [
      { accessor: 'by_haul', name: 'relic_name_haul_item_id_idx_btree', algorithm: 'btree', columns: [
        'haulItemId',
      ] },
      { accessor: 'id', name: 'relic_name_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'item_id', name: 'relic_name_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'world_id', name: 'relic_name_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'relic_name_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RelicNameRow),
  resolutionLog: __table({
    name: 'resolution_log',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ResolutionLogRow),
  rewardDivision: __table({
    name: 'reward_division',
    indexes: [
      { accessor: 'encounter_id', name: 'reward_division_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'world_id', name: 'reward_division_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'reward_division_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, RewardDivisionRow),
  rewardLock: __table({
    name: 'reward_lock',
    indexes: [
      { accessor: 'by_encounter', name: 'reward_lock_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'reward_lock_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'reward_lock_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RewardLockRow),
  rewardPile: __table({
    name: 'reward_pile',
    indexes: [
      { accessor: 'by_encounter', name: 'reward_pile_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'reward_pile_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'reward_pile_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RewardPileRow),
  serviceIdentity: __table({
    name: 'service_identity',
    indexes: [
      { accessor: 'identity', name: 'service_identity_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'service_identity_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ServiceIdentityRow),
  settlement: __table({
    name: 'settlement',
    indexes: [
      { accessor: 'instance_id', name: 'settlement_instance_id_idx_btree', algorithm: 'btree', columns: [
        'instanceId',
      ] },
    ],
    constraints: [
      { name: 'settlement_instance_id_key', constraint: 'unique', columns: ['instanceId'] },
    ],
  }, SettlementRow),
  sfxScore: __table({
    name: 'sfx_score',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, SfxScoreRow),
  shelfWorld: __table({
    name: 'shelf_world',
    indexes: [
      { accessor: 'world_id', name: 'shelf_world_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'shelf_world_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, ShelfWorldRow),
  spoilsSkim: __table({
    name: 'spoils_skim',
    indexes: [
      { accessor: 'by_encounter', name: 'spoils_skim_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'spoils_skim_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'spoils_skim_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, SpoilsSkimRow),
  upgradeGift: __table({
    name: 'upgrade_gift',
    indexes: [
      { accessor: 'hero_id', name: 'upgrade_gift_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'id', name: 'upgrade_gift_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'upgrade_gift_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'upgrade_gift_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, UpgradeGiftRow),
  village: __table({
    name: 'village',
    indexes: [
      { accessor: 'id', name: 'village_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'village_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'village_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VillageRow),
  villageFigures: __table({
    name: 'village_figures',
    indexes: [
      { accessor: 'owner', name: 'village_figures_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'world_id', name: 'village_figures_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'village_figures_owner_key', constraint: 'unique', columns: ['owner'] },
    ],
  }, VillageFiguresRow),
  villageMoment: __table({
    name: 'village_moment',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, VillageMomentRow),
  villageNpc: __table({
    name: 'village_npc',
    indexes: [
      { accessor: 'id', name: 'village_npc_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'village_id', name: 'village_npc_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'village_npc_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'village_npc_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VillageNpcRow),
  villagePresence: __table({
    name: 'village_presence',
    indexes: [
      { accessor: 'id', name: 'village_presence_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'village_presence_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'world_id', name: 'village_presence_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'village_presence_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VillagePresenceRow),
  villageSeat: __table({
    name: 'village_seat',
    indexes: [
      { accessor: 'id', name: 'village_seat_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'village_seat_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'village_id', name: 'village_seat_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'village_seat_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'village_seat_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VillageSeatRow),
  villageStock: __table({
    name: 'village_stock',
    indexes: [
      { accessor: 'id', name: 'village_stock_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'village_id', name: 'village_stock_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'village_stock_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'village_stock_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VillageStockRow),
  villageWorkshop: __table({
    name: 'village_workshop',
    indexes: [
      { accessor: 'id', name: 'village_workshop_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'village_id', name: 'village_workshop_village_id_idx_btree', algorithm: 'btree', columns: [
        'villageId',
      ] },
      { accessor: 'world_id', name: 'village_workshop_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'village_workshop_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VillageWorkshopRow),
  wildlife: __table({
    name: 'wildlife',
    indexes: [
      { accessor: 'encounter_id', name: 'wildlife_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'id', name: 'wildlife_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'wildlife_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WildlifeRow),
  wonderBlessing: __table({
    name: 'wonder_blessing',
    indexes: [
      { accessor: 'by_hero', name: 'wonder_blessing_hero_id_idx_btree', algorithm: 'btree', columns: [
        'heroId',
      ] },
      { accessor: 'id', name: 'wonder_blessing_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'wonder_blessing_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'world_id', name: 'wonder_blessing_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'wonder_blessing_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WonderBlessingRow),
  world: __table({
    name: 'world',
    indexes: [
      { accessor: 'id', name: 'world_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'world_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WorldRow),
  worldClock: __table({
    name: 'world_clock',
    indexes: [
      { accessor: 'world_id', name: 'world_clock_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_clock_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldClockRow),
  worldMember: __table({
    name: 'world_member',
    indexes: [
      { accessor: 'id', name: 'world_member_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'world_member_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'world_id', name: 'world_member_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'by_world_owner', name: 'world_member_world_id_owner_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'owner',
      ] },
    ],
    constraints: [
      { name: 'world_member_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WorldMemberRow),
  worldOpening: __table({
    name: 'world_opening',
    indexes: [
      { accessor: 'world_id', name: 'world_opening_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_opening_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldOpeningRow),
  worldPing: __table({
    name: 'world_ping',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, WorldPingRow),
  worldPresence: __table({
    name: 'world_presence',
    indexes: [
      { accessor: 'id', name: 'world_presence_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'world_id', name: 'world_presence_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'by_world_owner', name: 'world_presence_world_id_owner_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'owner',
      ] },
    ],
    constraints: [
      { name: 'world_presence_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WorldPresenceRow),
  worldSettings: __table({
    name: 'world_settings',
    indexes: [
      { accessor: 'world_id', name: 'world_settings_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_settings_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldSettingsRow),
  worldStory: __table({
    name: 'world_story',
    indexes: [
      { accessor: 'world_id', name: 'world_story_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_story_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldStoryRow),
  myAccount: __table({
    name: 'my_account',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAccountRow),
  myCollectedPieces: __table({
    name: 'my_collected_pieces',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCollectedPiecesRow),
  myFriendships: __table({
    name: 'my_friendships',
    indexes: [
    ],
    constraints: [
    ],
  }, MyFriendshipsRow),
  myHeroes: __table({
    name: 'my_heroes',
    indexes: [
    ],
    constraints: [
    ],
  }, MyHeroesRow),
  myInventory: __table({
    name: 'my_inventory',
    indexes: [
    ],
    constraints: [
    ],
  }, MyInventoryRow),
  myLevelUpOffers: __table({
    name: 'my_level_up_offers',
    indexes: [
    ],
    constraints: [
    ],
  }, MyLevelUpOffersRow),
  myPlayerSetting: __table({
    name: 'my_player_setting',
    indexes: [
    ],
    constraints: [
    ],
  }, MyPlayerSettingRow),
  myTrades: __table({
    name: 'my_trades',
    indexes: [
    ],
    constraints: [
    ],
  }, MyTradesRow),
  myVillageKnown: __table({
    name: 'my_village_known',
    indexes: [
    ],
    constraints: [
    ],
  }, MyVillageKnownRow),
  myWorldInvites: __table({
    name: 'my_world_invites',
    indexes: [
    ],
    constraints: [
    ],
  }, MyWorldInvitesRow),
  myWorldMessages: __table({
    name: 'my_world_messages',
    indexes: [
    ],
    constraints: [
    ],
  }, MyWorldMessagesRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("abandon_adventure", AbandonAdventureReducer),
  __reducerSchema("abandon_encounter", AbandonEncounterReducer),
  __reducerSchema("accept_offer", AcceptOfferReducer),
  __reducerSchema("accept_surrender", AcceptSurrenderReducer),
  __reducerSchema("accept_trade", AcceptTradeReducer),
  __reducerSchema("accept_upgrade_gift", AcceptUpgradeGiftReducer),
  __reducerSchema("admin_audit_note", AdminAuditNoteReducer),
  __reducerSchema("admin_fail_job", AdminFailJobReducer),
  __reducerSchema("admin_requeue_job", AdminRequeueJobReducer),
  __reducerSchema("admin_unmake_shelf_world", AdminUnmakeShelfWorldReducer),
  __reducerSchema("answer_band_call", AnswerBandCallReducer),
  __reducerSchema("assume_control", AssumeControlReducer),
  __reducerSchema("begin_world", BeginWorldReducer),
  __reducerSchema("buy_boost", BuyBoostReducer),
  __reducerSchema("buy_hint", BuyHintReducer),
  __reducerSchema("buy_market_piece", BuyMarketPieceReducer),
  __reducerSchema("buy_pack", BuyPackReducer),
  __reducerSchema("buy_secret", BuySecretReducer),
  __reducerSchema("buy_stock", BuyStockReducer),
  __reducerSchema("buy_trade", BuyTradeReducer),
  __reducerSchema("call_flee", CallFleeReducer),
  __reducerSchema("cancel_flee", CancelFleeReducer),
  __reducerSchema("cancel_trade", CancelTradeReducer),
  __reducerSchema("choose_colour", ChooseColourReducer),
  __reducerSchema("choose_level_up", ChooseLevelUpReducer),
  __reducerSchema("choose_wonder_blessing", ChooseWonderBlessingReducer),
  __reducerSchema("claim_job", ClaimJobReducer),
  __reducerSchema("claim_pile", ClaimPileReducer),
  __reducerSchema("claim_username", ClaimUsernameReducer),
  __reducerSchema("clear_spent_inputs", ClearSpentInputsReducer),
  __reducerSchema("commit_hero", CommitHeroReducer),
  __reducerSchema("create_hero", CreateHeroReducer),
  __reducerSchema("create_party", CreatePartyReducer),
  __reducerSchema("create_world", CreateWorldReducer),
  __reducerSchema("decline_trade", DeclineTradeReducer),
  __reducerSchema("decline_upgrade_gift", DeclineUpgradeGiftReducer),
  __reducerSchema("deliver_campaign_quest", DeliverCampaignQuestReducer),
  __reducerSchema("deliver_chapter_scene", DeliverChapterSceneReducer),
  __reducerSchema("deliver_chronicle_voice", DeliverChronicleVoiceReducer),
  __reducerSchema("deliver_generation", DeliverGenerationReducer),
  __reducerSchema("deliver_quest_endings", DeliverQuestEndingsReducer),
  __reducerSchema("deliver_relic_name", DeliverRelicNameReducer),
  __reducerSchema("deliver_side_quests", DeliverSideQuestsReducer),
  __reducerSchema("deliver_village", DeliverVillageReducer),
  __reducerSchema("deliver_village_talk", DeliverVillageTalkReducer),
  __reducerSchema("deliver_world_genesis", DeliverWorldGenesisReducer),
  __reducerSchema("dev_beside_find", DevBesideFindReducer),
  __reducerSchema("dev_beside_snare", DevBesideSnareReducer),
  __reducerSchema("dev_beside_wonder", DevBesideWonderReducer),
  __reducerSchema("dev_clear_foes", DevClearFoesReducer),
  __reducerSchema("dev_close_chapter", DevCloseChapterReducer),
  __reducerSchema("dev_end_encounter", DevEndEncounterReducer),
  __reducerSchema("dev_grant_gold", DevGrantGoldReducer),
  __reducerSchema("dev_grant_item", DevGrantItemReducer),
  __reducerSchema("dev_grant_upgrade_gift", DevGrantUpgradeGiftReducer),
  __reducerSchema("dev_grant_xp", DevGrantXpReducer),
  __reducerSchema("dev_name_foe", DevNameFoeReducer),
  __reducerSchema("dev_offer_wonder_blessing", DevOfferWonderBlessingReducer),
  __reducerSchema("dev_open_stashes", DevOpenStashesReducer),
  __reducerSchema("dev_open_workshop", DevOpenWorkshopReducer),
  __reducerSchema("dev_place_matter", DevPlaceMatterReducer),
  __reducerSchema("dev_plant_secrets", DevPlantSecretsReducer),
  __reducerSchema("dev_secure_encounter", DevSecureEncounterReducer),
  __reducerSchema("dev_set_fog", DevSetFogReducer),
  __reducerSchema("dev_set_host", DevSetHostReducer),
  __reducerSchema("dev_set_hp", DevSetHpReducer),
  __reducerSchema("dev_set_scene", DevSetSceneReducer),
  __reducerSchema("dev_set_size", DevSetSizeReducer),
  __reducerSchema("dev_set_sky", DevSetSkyReducer),
  __reducerSchema("dev_settle_adventure", DevSettleAdventureReducer),
  __reducerSchema("dev_spring_trouble", DevSpringTroubleReducer),
  __reducerSchema("dice_hold", DiceHoldReducer),
  __reducerSchema("dice_sit", DiceSitReducer),
  __reducerSchema("dice_stand", DiceStandReducer),
  __reducerSchema("dice_start", DiceStartReducer),
  __reducerSchema("dice_throw", DiceThrowReducer),
  __reducerSchema("dice_tick", DiceTickReducer),
  __reducerSchema("discard_item", DiscardItemReducer),
  __reducerSchema("dismiss_hero", DismissHeroReducer),
  __reducerSchema("dye_item", DyeItemReducer),
  __reducerSchema("end_band_call", EndBandCallReducer),
  __reducerSchema("enqueue_generation", EnqueueGenerationReducer),
  __reducerSchema("ensure_villages", EnsureVillagesReducer),
  __reducerSchema("enter_village", EnterVillageReducer),
  __reducerSchema("equip", EquipReducer),
  __reducerSchema("equip_to", EquipToReducer),
  __reducerSchema("fail_job", FailJobReducer),
  __reducerSchema("finish_encounter", FinishEncounterReducer),
  __reducerSchema("finish_meal", FinishMealReducer),
  __reducerSchema("finish_outfitting", FinishOutfittingReducer),
  __reducerSchema("force_door", ForceDoorReducer),
  __reducerSchema("forge_hero", ForgeHeroReducer),
  __reducerSchema("forge_hero_called", ForgeHeroCalledReducer),
  __reducerSchema("forge_hero_voiced", ForgeHeroVoicedReducer),
  __reducerSchema("give_item", GiveItemReducer),
  __reducerSchema("go_solo", GoSoloReducer),
  __reducerSchema("grant_module_admin", GrantModuleAdminReducer),
  __reducerSchema("heartbeat", HeartbeatReducer),
  __reducerSchema("hire_villager", HireVillagerReducer),
  __reducerSchema("inn_toast", InnToastReducer),
  __reducerSchema("invite_to_world", InviteToWorldReducer),
  __reducerSchema("join_band", JoinBandReducer),
  __reducerSchema("join_opening", JoinOpeningReducer),
  __reducerSchema("join_party", JoinPartyReducer),
  __reducerSchema("join_world", JoinWorldReducer),
  __reducerSchema("kick_from_world", KickFromWorldReducer),
  __reducerSchema("learn_talent", LearnTalentReducer),
  __reducerSchema("leave_party", LeavePartyReducer),
  __reducerSchema("leave_village", LeaveVillageReducer),
  __reducerSchema("leave_world_lobby", LeaveWorldLobbyReducer),
  __reducerSchema("lock_rewards", LockRewardsReducer),
  __reducerSchema("muster", MusterReducer),
  __reducerSchema("offer_trade", OfferTradeReducer),
  __reducerSchema("open_world_lobby", OpenWorldLobbyReducer),
  __reducerSchema("opening_read", OpeningReadReducer),
  __reducerSchema("opening_ready", OpeningReadyReducer),
  __reducerSchema("order_drink", OrderDrinkReducer),
  __reducerSchema("order_meal", OrderMealReducer),
  __reducerSchema("pause", PauseReducer),
  __reducerSchema("pick_progress", PickProgressReducer),
  __reducerSchema("pin_notice", PinNoticeReducer),
  __reducerSchema("ping_board", PingBoardReducer),
  __reducerSchema("ping_quest", PingQuestReducer),
  __reducerSchema("ping_world", PingWorldReducer),
  __reducerSchema("plan_route", PlanRouteReducer),
  __reducerSchema("ready", ReadyReducer),
  __reducerSchema("redye_hero", RedyeHeroReducer),
  __reducerSchema("reforge_hero", ReforgeHeroReducer),
  __reducerSchema("refresh_offers", RefreshOffersReducer),
  __reducerSchema("refuse_surrender", RefuseSurrenderReducer),
  __reducerSchema("register_service_identity", RegisterServiceIdentityReducer),
  __reducerSchema("release_control", ReleaseControlReducer),
  __reducerSchema("release_pile", ReleasePileReducer),
  __reducerSchema("remove_friend", RemoveFriendReducer),
  __reducerSchema("remove_service_identity", RemoveServiceIdentityReducer),
  __reducerSchema("rename_hero", RenameHeroReducer),
  __reducerSchema("rename_lobby", RenameLobbyReducer),
  __reducerSchema("rent_room", RentRoomReducer),
  __reducerSchema("request_song", RequestSongReducer),
  __reducerSchema("respond_friend_request", RespondFriendRequestReducer),
  __reducerSchema("respond_world_invite", RespondWorldInviteReducer),
  __reducerSchema("restyle_hero", RestyleHeroReducer),
  __reducerSchema("resume", ResumeReducer),
  __reducerSchema("retire_hero", RetireHeroReducer),
  __reducerSchema("retrain_hero", RetrainHeroReducer),
  __reducerSchema("retry_story", RetryStoryReducer),
  __reducerSchema("return_boost", ReturnBoostReducer),
  __reducerSchema("revoke_module_admin", RevokeModuleAdminReducer),
  __reducerSchema("see_collected", SeeCollectedReducer),
  __reducerSchema("sell_item", SellItemReducer),
  __reducerSchema("send_emote", SendEmoteReducer),
  __reducerSchema("send_friend_request", SendFriendRequestReducer),
  __reducerSchema("send_party_message", SendPartyMessageReducer),
  __reducerSchema("send_world_message", SendWorldMessageReducer),
  __reducerSchema("set_allow_pausing", SetAllowPausingReducer),
  __reducerSchema("set_allow_uncensored", SetAllowUncensoredReducer),
  __reducerSchema("set_deadline", SetDeadlineReducer),
  __reducerSchema("set_display_name", SetDisplayNameReducer),
  __reducerSchema("set_gear_plan", SetGearPlanReducer),
  __reducerSchema("set_hero_voice", SetHeroVoiceReducer),
  __reducerSchema("set_kill_streaks", SetKillStreaksReducer),
  __reducerSchema("set_lobby_ready", SetLobbyReadyReducer),
  __reducerSchema("set_lobby_storyteller", SetLobbyStorytellerReducer),
  __reducerSchema("set_party_window", SetPartyWindowReducer),
  __reducerSchema("share_moment", ShareMomentReducer),
  __reducerSchema("sign_guestbook", SignGuestbookReducer),
  __reducerSchema("stand_round", StandRoundReducer),
  __reducerSchema("start_encounter", StartEncounterReducer),
  __reducerSchema("submit_intent", SubmitIntentReducer),
  __reducerSchema("take_level", TakeLevelReducer),
  __reducerSchema("take_up_offer", TakeUpOfferReducer),
  __reducerSchema("train_hero", TrainHeroReducer),
  __reducerSchema("transfer_control", TransferControlReducer),
  __reducerSchema("travel_to_site", TravelToSiteReducer),
  __reducerSchema("uncommit_hero", UncommitHeroReducer),
  __reducerSchema("unequip", UnequipReducer),
  __reducerSchema("unfinish_encounter", UnfinishEncounterReducer),
  __reducerSchema("unlock_rewards", UnlockRewardsReducer),
  __reducerSchema("unpin_notice", UnpinNoticeReducer),
  __reducerSchema("unready", UnreadyReducer),
  __reducerSchema("update_world_settings", UpdateWorldSettingsReducer),
  __reducerSchema("upgrade_item", UpgradeItemReducer),
  __reducerSchema("use_item_in_camp", UseItemInCampReducer),
  __reducerSchema("village_go", VillageGoReducer),
  __reducerSchema("village_move", VillageMoveReducer),
  __reducerSchema("village_sit", VillageSitReducer),
  __reducerSchema("village_stand", VillageStandReducer),
  __reducerSchema("walk_band", WalkBandReducer),
  __reducerSchema("withdraw_intent", WithdrawIntentReducer),
  __reducerSchema("worker_heartbeat", WorkerHeartbeatReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `adventureInstance` instead. This alias will be removed in the next major version. */
    readonly "adventure_instance": Omit<typeof tablesSchema.schemaType.tables["adventureInstance"], "accessorName"> & { readonly accessorName: "adventure_instance" };
    /** @deprecated Use `bandCall` instead. This alias will be removed in the next major version. */
    readonly "band_call": Omit<typeof tablesSchema.schemaType.tables["bandCall"], "accessorName"> & { readonly accessorName: "band_call" };
    /** @deprecated Use `boardPing` instead. This alias will be removed in the next major version. */
    readonly "board_ping": Omit<typeof tablesSchema.schemaType.tables["boardPing"], "accessorName"> & { readonly accessorName: "board_ping" };
    /** @deprecated Use `bookChapter` instead. This alias will be removed in the next major version. */
    readonly "book_chapter": Omit<typeof tablesSchema.schemaType.tables["bookChapter"], "accessorName"> & { readonly accessorName: "book_chapter" };
    /** @deprecated Use `campaignProgress` instead. This alias will be removed in the next major version. */
    readonly "campaign_progress": Omit<typeof tablesSchema.schemaType.tables["campaignProgress"], "accessorName"> & { readonly accessorName: "campaign_progress" };
    /** @deprecated Use `chronicleEvent` instead. This alias will be removed in the next major version. */
    readonly "chronicle_event": Omit<typeof tablesSchema.schemaType.tables["chronicleEvent"], "accessorName"> & { readonly accessorName: "chronicle_event" };
    /** @deprecated Use `chronicleVoice` instead. This alias will be removed in the next major version. */
    readonly "chronicle_voice": Omit<typeof tablesSchema.schemaType.tables["chronicleVoice"], "accessorName"> & { readonly accessorName: "chronicle_voice" };
    /** @deprecated Use `clientCompat` instead. This alias will be removed in the next major version. */
    readonly "client_compat": Omit<typeof tablesSchema.schemaType.tables["clientCompat"], "accessorName"> & { readonly accessorName: "client_compat" };
    /** @deprecated Use `controlGrant` instead. This alias will be removed in the next major version. */
    readonly "control_grant": Omit<typeof tablesSchema.schemaType.tables["controlGrant"], "accessorName"> & { readonly accessorName: "control_grant" };
    /** @deprecated Use `crawlForce` instead. This alias will be removed in the next major version. */
    readonly "crawl_force": Omit<typeof tablesSchema.schemaType.tables["crawlForce"], "accessorName"> & { readonly accessorName: "crawl_force" };
    /** @deprecated Use `diceTable` instead. This alias will be removed in the next major version. */
    readonly "dice_table": Omit<typeof tablesSchema.schemaType.tables["diceTable"], "accessorName"> & { readonly accessorName: "dice_table" };
    /** @deprecated Use `encounterBoon` instead. This alias will be removed in the next major version. */
    readonly "encounter_boon": Omit<typeof tablesSchema.schemaType.tables["encounterBoon"], "accessorName"> & { readonly accessorName: "encounter_boon" };
    /** @deprecated Use `encounterHaul` instead. This alias will be removed in the next major version. */
    readonly "encounter_haul": Omit<typeof tablesSchema.schemaType.tables["encounterHaul"], "accessorName"> & { readonly accessorName: "encounter_haul" };
    /** @deprecated Use `encounterResult` instead. This alias will be removed in the next major version. */
    readonly "encounter_result": Omit<typeof tablesSchema.schemaType.tables["encounterResult"], "accessorName"> & { readonly accessorName: "encounter_result" };
    /** @deprecated Use `encounterSecured` instead. This alias will be removed in the next major version. */
    readonly "encounter_secured": Omit<typeof tablesSchema.schemaType.tables["encounterSecured"], "accessorName"> & { readonly accessorName: "encounter_secured" };
    /** @deprecated Use `encounterStage` instead. This alias will be removed in the next major version. */
    readonly "encounter_stage": Omit<typeof tablesSchema.schemaType.tables["encounterStage"], "accessorName"> & { readonly accessorName: "encounter_stage" };
    /** @deprecated Use `finishVote` instead. This alias will be removed in the next major version. */
    readonly "finish_vote": Omit<typeof tablesSchema.schemaType.tables["finishVote"], "accessorName"> & { readonly accessorName: "finish_vote" };
    /** @deprecated Use `foeFate` instead. This alias will be removed in the next major version. */
    readonly "foe_fate": Omit<typeof tablesSchema.schemaType.tables["foeFate"], "accessorName"> & { readonly accessorName: "foe_fate" };
    /** @deprecated Use `foundingKit` instead. This alias will be removed in the next major version. */
    readonly "founding_kit": Omit<typeof tablesSchema.schemaType.tables["foundingKit"], "accessorName"> & { readonly accessorName: "founding_kit" };
    /** @deprecated Use `foundingMarket` instead. This alias will be removed in the next major version. */
    readonly "founding_market": Omit<typeof tablesSchema.schemaType.tables["foundingMarket"], "accessorName"> & { readonly accessorName: "founding_market" };
    /** @deprecated Use `foundingOutfit` instead. This alias will be removed in the next major version. */
    readonly "founding_outfit": Omit<typeof tablesSchema.schemaType.tables["foundingOutfit"], "accessorName"> & { readonly accessorName: "founding_outfit" };
    /** @deprecated Use `foundingPurse` instead. This alias will be removed in the next major version. */
    readonly "founding_purse": Omit<typeof tablesSchema.schemaType.tables["foundingPurse"], "accessorName"> & { readonly accessorName: "founding_purse" };
    /** @deprecated Use `frozenInstance` instead. This alias will be removed in the next major version. */
    readonly "frozen_instance": Omit<typeof tablesSchema.schemaType.tables["frozenInstance"], "accessorName"> & { readonly accessorName: "frozen_instance" };
    /** @deprecated Use `gearPlan` instead. This alias will be removed in the next major version. */
    readonly "gear_plan": Omit<typeof tablesSchema.schemaType.tables["gearPlan"], "accessorName"> & { readonly accessorName: "gear_plan" };
    /** @deprecated Use `generationJob` instead. This alias will be removed in the next major version. */
    readonly "generation_job": Omit<typeof tablesSchema.schemaType.tables["generationJob"], "accessorName"> & { readonly accessorName: "generation_job" };
    /** @deprecated Use `haulGold` instead. This alias will be removed in the next major version. */
    readonly "haul_gold": Omit<typeof tablesSchema.schemaType.tables["haulGold"], "accessorName"> & { readonly accessorName: "haul_gold" };
    /** @deprecated Use `haulItem` instead. This alias will be removed in the next major version. */
    readonly "haul_item": Omit<typeof tablesSchema.schemaType.tables["haulItem"], "accessorName"> & { readonly accessorName: "haul_item" };
    /** @deprecated Use `heroBoon` instead. This alias will be removed in the next major version. */
    readonly "hero_boon": Omit<typeof tablesSchema.schemaType.tables["heroBoon"], "accessorName"> & { readonly accessorName: "hero_boon" };
    /** @deprecated Use `heroCalling` instead. This alias will be removed in the next major version. */
    readonly "hero_calling": Omit<typeof tablesSchema.schemaType.tables["heroCalling"], "accessorName"> & { readonly accessorName: "hero_calling" };
    /** @deprecated Use `heroDye` instead. This alias will be removed in the next major version. */
    readonly "hero_dye": Omit<typeof tablesSchema.schemaType.tables["heroDye"], "accessorName"> & { readonly accessorName: "hero_dye" };
    /** @deprecated Use `heroEmote` instead. This alias will be removed in the next major version. */
    readonly "hero_emote": Omit<typeof tablesSchema.schemaType.tables["heroEmote"], "accessorName"> & { readonly accessorName: "hero_emote" };
    /** @deprecated Use `heroMeal` instead. This alias will be removed in the next major version. */
    readonly "hero_meal": Omit<typeof tablesSchema.schemaType.tables["heroMeal"], "accessorName"> & { readonly accessorName: "hero_meal" };
    /** @deprecated Use `heroOrigin` instead. This alias will be removed in the next major version. */
    readonly "hero_origin": Omit<typeof tablesSchema.schemaType.tables["heroOrigin"], "accessorName"> & { readonly accessorName: "hero_origin" };
    /** @deprecated Use `heroPack` instead. This alias will be removed in the next major version. */
    readonly "hero_pack": Omit<typeof tablesSchema.schemaType.tables["heroPack"], "accessorName"> & { readonly accessorName: "hero_pack" };
    /** @deprecated Use `heroProgress` instead. This alias will be removed in the next major version. */
    readonly "hero_progress": Omit<typeof tablesSchema.schemaType.tables["heroProgress"], "accessorName"> & { readonly accessorName: "hero_progress" };
    /** @deprecated Use `heroRoute` instead. This alias will be removed in the next major version. */
    readonly "hero_route": Omit<typeof tablesSchema.schemaType.tables["heroRoute"], "accessorName"> & { readonly accessorName: "hero_route" };
    /** @deprecated Use `heroVoice` instead. This alias will be removed in the next major version. */
    readonly "hero_voice": Omit<typeof tablesSchema.schemaType.tables["heroVoice"], "accessorName"> & { readonly accessorName: "hero_voice" };
    /** @deprecated Use `innCheer` instead. This alias will be removed in the next major version. */
    readonly "inn_cheer": Omit<typeof tablesSchema.schemaType.tables["innCheer"], "accessorName"> & { readonly accessorName: "inn_cheer" };
    /** @deprecated Use `innGuestbook` instead. This alias will be removed in the next major version. */
    readonly "inn_guestbook": Omit<typeof tablesSchema.schemaType.tables["innGuestbook"], "accessorName"> & { readonly accessorName: "inn_guestbook" };
    /** @deprecated Use `innNotice` instead. This alias will be removed in the next major version. */
    readonly "inn_notice": Omit<typeof tablesSchema.schemaType.tables["innNotice"], "accessorName"> & { readonly accessorName: "inn_notice" };
    /** @deprecated Use `innRent` instead. This alias will be removed in the next major version. */
    readonly "inn_rent": Omit<typeof tablesSchema.schemaType.tables["innRent"], "accessorName"> & { readonly accessorName: "inn_rent" };
    /** @deprecated Use `innSong` instead. This alias will be removed in the next major version. */
    readonly "inn_song": Omit<typeof tablesSchema.schemaType.tables["innSong"], "accessorName"> & { readonly accessorName: "inn_song" };
    /** @deprecated Use `innVisit` instead. This alias will be removed in the next major version. */
    readonly "inn_visit": Omit<typeof tablesSchema.schemaType.tables["innVisit"], "accessorName"> & { readonly accessorName: "inn_visit" };
    /** @deprecated Use `itemDye` instead. This alias will be removed in the next major version. */
    readonly "item_dye": Omit<typeof tablesSchema.schemaType.tables["itemDye"], "accessorName"> & { readonly accessorName: "item_dye" };
    /** @deprecated Use `itemUpgrade` instead. This alias will be removed in the next major version. */
    readonly "item_upgrade": Omit<typeof tablesSchema.schemaType.tables["itemUpgrade"], "accessorName"> & { readonly accessorName: "item_upgrade" };
    /** @deprecated Use `levelUpOffer` instead. This alias will be removed in the next major version. */
    readonly "level_up_offer": Omit<typeof tablesSchema.schemaType.tables["levelUpOffer"], "accessorName"> & { readonly accessorName: "level_up_offer" };
    /** @deprecated Use `lobbySeat` instead. This alias will be removed in the next major version. */
    readonly "lobby_seat": Omit<typeof tablesSchema.schemaType.tables["lobbySeat"], "accessorName"> & { readonly accessorName: "lobby_seat" };
    /** @deprecated Use `locationStatus` instead. This alias will be removed in the next major version. */
    readonly "location_status": Omit<typeof tablesSchema.schemaType.tables["locationStatus"], "accessorName"> & { readonly accessorName: "location_status" };
    /** @deprecated Use `lootDraw` instead. This alias will be removed in the next major version. */
    readonly "loot_draw": Omit<typeof tablesSchema.schemaType.tables["lootDraw"], "accessorName"> & { readonly accessorName: "loot_draw" };
    /** @deprecated Use `namedCharacter` instead. This alias will be removed in the next major version. */
    readonly "named_character": Omit<typeof tablesSchema.schemaType.tables["namedCharacter"], "accessorName"> & { readonly accessorName: "named_character" };
    /** @deprecated Use `partyMember` instead. This alias will be removed in the next major version. */
    readonly "party_member": Omit<typeof tablesSchema.schemaType.tables["partyMember"], "accessorName"> & { readonly accessorName: "party_member" };
    /** @deprecated Use `partyMessage` instead. This alias will be removed in the next major version. */
    readonly "party_message": Omit<typeof tablesSchema.schemaType.tables["partyMessage"], "accessorName"> & { readonly accessorName: "party_message" };
    /** @deprecated Use `partyWalk` instead. This alias will be removed in the next major version. */
    readonly "party_walk": Omit<typeof tablesSchema.schemaType.tables["partyWalk"], "accessorName"> & { readonly accessorName: "party_walk" };
    /** @deprecated Use `pauseState` instead. This alias will be removed in the next major version. */
    readonly "pause_state": Omit<typeof tablesSchema.schemaType.tables["pauseState"], "accessorName"> & { readonly accessorName: "pause_state" };
    /** @deprecated Use `playerColour` instead. This alias will be removed in the next major version. */
    readonly "player_colour": Omit<typeof tablesSchema.schemaType.tables["playerColour"], "accessorName"> & { readonly accessorName: "player_colour" };
    /** @deprecated Use `playerProfile` instead. This alias will be removed in the next major version. */
    readonly "player_profile": Omit<typeof tablesSchema.schemaType.tables["playerProfile"], "accessorName"> & { readonly accessorName: "player_profile" };
    /** @deprecated Use `puzzleNote` instead. This alias will be removed in the next major version. */
    readonly "puzzle_note": Omit<typeof tablesSchema.schemaType.tables["puzzleNote"], "accessorName"> & { readonly accessorName: "puzzle_note" };
    /** @deprecated Use `puzzleRoom` instead. This alias will be removed in the next major version. */
    readonly "puzzle_room": Omit<typeof tablesSchema.schemaType.tables["puzzleRoom"], "accessorName"> & { readonly accessorName: "puzzle_room" };
    /** @deprecated Use `questPing` instead. This alias will be removed in the next major version. */
    readonly "quest_ping": Omit<typeof tablesSchema.schemaType.tables["questPing"], "accessorName"> & { readonly accessorName: "quest_ping" };
    /** @deprecated Use `questStage` instead. This alias will be removed in the next major version. */
    readonly "quest_stage": Omit<typeof tablesSchema.schemaType.tables["questStage"], "accessorName"> & { readonly accessorName: "quest_stage" };
    /** @deprecated Use `questWound` instead. This alias will be removed in the next major version. */
    readonly "quest_wound": Omit<typeof tablesSchema.schemaType.tables["questWound"], "accessorName"> & { readonly accessorName: "quest_wound" };
    /** @deprecated Use `readyState` instead. This alias will be removed in the next major version. */
    readonly "ready_state": Omit<typeof tablesSchema.schemaType.tables["readyState"], "accessorName"> & { readonly accessorName: "ready_state" };
    /** @deprecated Use `regardRow` instead. This alias will be removed in the next major version. */
    readonly "regard_row": Omit<typeof tablesSchema.schemaType.tables["regardRow"], "accessorName"> & { readonly accessorName: "regard_row" };
    /** @deprecated Use `relicName` instead. This alias will be removed in the next major version. */
    readonly "relic_name": Omit<typeof tablesSchema.schemaType.tables["relicName"], "accessorName"> & { readonly accessorName: "relic_name" };
    /** @deprecated Use `resolutionLog` instead. This alias will be removed in the next major version. */
    readonly "resolution_log": Omit<typeof tablesSchema.schemaType.tables["resolutionLog"], "accessorName"> & { readonly accessorName: "resolution_log" };
    /** @deprecated Use `rewardDivision` instead. This alias will be removed in the next major version. */
    readonly "reward_division": Omit<typeof tablesSchema.schemaType.tables["rewardDivision"], "accessorName"> & { readonly accessorName: "reward_division" };
    /** @deprecated Use `rewardLock` instead. This alias will be removed in the next major version. */
    readonly "reward_lock": Omit<typeof tablesSchema.schemaType.tables["rewardLock"], "accessorName"> & { readonly accessorName: "reward_lock" };
    /** @deprecated Use `rewardPile` instead. This alias will be removed in the next major version. */
    readonly "reward_pile": Omit<typeof tablesSchema.schemaType.tables["rewardPile"], "accessorName"> & { readonly accessorName: "reward_pile" };
    /** @deprecated Use `serviceIdentity` instead. This alias will be removed in the next major version. */
    readonly "service_identity": Omit<typeof tablesSchema.schemaType.tables["serviceIdentity"], "accessorName"> & { readonly accessorName: "service_identity" };
    /** @deprecated Use `sfxScore` instead. This alias will be removed in the next major version. */
    readonly "sfx_score": Omit<typeof tablesSchema.schemaType.tables["sfxScore"], "accessorName"> & { readonly accessorName: "sfx_score" };
    /** @deprecated Use `shelfWorld` instead. This alias will be removed in the next major version. */
    readonly "shelf_world": Omit<typeof tablesSchema.schemaType.tables["shelfWorld"], "accessorName"> & { readonly accessorName: "shelf_world" };
    /** @deprecated Use `spoilsSkim` instead. This alias will be removed in the next major version. */
    readonly "spoils_skim": Omit<typeof tablesSchema.schemaType.tables["spoilsSkim"], "accessorName"> & { readonly accessorName: "spoils_skim" };
    /** @deprecated Use `upgradeGift` instead. This alias will be removed in the next major version. */
    readonly "upgrade_gift": Omit<typeof tablesSchema.schemaType.tables["upgradeGift"], "accessorName"> & { readonly accessorName: "upgrade_gift" };
    /** @deprecated Use `villageFigures` instead. This alias will be removed in the next major version. */
    readonly "village_figures": Omit<typeof tablesSchema.schemaType.tables["villageFigures"], "accessorName"> & { readonly accessorName: "village_figures" };
    /** @deprecated Use `villageMoment` instead. This alias will be removed in the next major version. */
    readonly "village_moment": Omit<typeof tablesSchema.schemaType.tables["villageMoment"], "accessorName"> & { readonly accessorName: "village_moment" };
    /** @deprecated Use `villageNpc` instead. This alias will be removed in the next major version. */
    readonly "village_npc": Omit<typeof tablesSchema.schemaType.tables["villageNpc"], "accessorName"> & { readonly accessorName: "village_npc" };
    /** @deprecated Use `villagePresence` instead. This alias will be removed in the next major version. */
    readonly "village_presence": Omit<typeof tablesSchema.schemaType.tables["villagePresence"], "accessorName"> & { readonly accessorName: "village_presence" };
    /** @deprecated Use `villageSeat` instead. This alias will be removed in the next major version. */
    readonly "village_seat": Omit<typeof tablesSchema.schemaType.tables["villageSeat"], "accessorName"> & { readonly accessorName: "village_seat" };
    /** @deprecated Use `villageStock` instead. This alias will be removed in the next major version. */
    readonly "village_stock": Omit<typeof tablesSchema.schemaType.tables["villageStock"], "accessorName"> & { readonly accessorName: "village_stock" };
    /** @deprecated Use `villageWorkshop` instead. This alias will be removed in the next major version. */
    readonly "village_workshop": Omit<typeof tablesSchema.schemaType.tables["villageWorkshop"], "accessorName"> & { readonly accessorName: "village_workshop" };
    /** @deprecated Use `wonderBlessing` instead. This alias will be removed in the next major version. */
    readonly "wonder_blessing": Omit<typeof tablesSchema.schemaType.tables["wonderBlessing"], "accessorName"> & { readonly accessorName: "wonder_blessing" };
    /** @deprecated Use `worldClock` instead. This alias will be removed in the next major version. */
    readonly "world_clock": Omit<typeof tablesSchema.schemaType.tables["worldClock"], "accessorName"> & { readonly accessorName: "world_clock" };
    /** @deprecated Use `worldMember` instead. This alias will be removed in the next major version. */
    readonly "world_member": Omit<typeof tablesSchema.schemaType.tables["worldMember"], "accessorName"> & { readonly accessorName: "world_member" };
    /** @deprecated Use `worldOpening` instead. This alias will be removed in the next major version. */
    readonly "world_opening": Omit<typeof tablesSchema.schemaType.tables["worldOpening"], "accessorName"> & { readonly accessorName: "world_opening" };
    /** @deprecated Use `worldPing` instead. This alias will be removed in the next major version. */
    readonly "world_ping": Omit<typeof tablesSchema.schemaType.tables["worldPing"], "accessorName"> & { readonly accessorName: "world_ping" };
    /** @deprecated Use `worldPresence` instead. This alias will be removed in the next major version. */
    readonly "world_presence": Omit<typeof tablesSchema.schemaType.tables["worldPresence"], "accessorName"> & { readonly accessorName: "world_presence" };
    /** @deprecated Use `worldSettings` instead. This alias will be removed in the next major version. */
    readonly "world_settings": Omit<typeof tablesSchema.schemaType.tables["worldSettings"], "accessorName"> & { readonly accessorName: "world_settings" };
    /** @deprecated Use `worldStory` instead. This alias will be removed in the next major version. */
    readonly "world_story": Omit<typeof tablesSchema.schemaType.tables["worldStory"], "accessorName"> & { readonly accessorName: "world_story" };
    /** @deprecated Use `myAccount` instead. This alias will be removed in the next major version. */
    readonly "my_account": Omit<typeof tablesSchema.schemaType.tables["myAccount"], "accessorName"> & { readonly accessorName: "my_account" };
    /** @deprecated Use `myCollectedPieces` instead. This alias will be removed in the next major version. */
    readonly "my_collected_pieces": Omit<typeof tablesSchema.schemaType.tables["myCollectedPieces"], "accessorName"> & { readonly accessorName: "my_collected_pieces" };
    /** @deprecated Use `myFriendships` instead. This alias will be removed in the next major version. */
    readonly "my_friendships": Omit<typeof tablesSchema.schemaType.tables["myFriendships"], "accessorName"> & { readonly accessorName: "my_friendships" };
    /** @deprecated Use `myHeroes` instead. This alias will be removed in the next major version. */
    readonly "my_heroes": Omit<typeof tablesSchema.schemaType.tables["myHeroes"], "accessorName"> & { readonly accessorName: "my_heroes" };
    /** @deprecated Use `myInventory` instead. This alias will be removed in the next major version. */
    readonly "my_inventory": Omit<typeof tablesSchema.schemaType.tables["myInventory"], "accessorName"> & { readonly accessorName: "my_inventory" };
    /** @deprecated Use `myLevelUpOffers` instead. This alias will be removed in the next major version. */
    readonly "my_level_up_offers": Omit<typeof tablesSchema.schemaType.tables["myLevelUpOffers"], "accessorName"> & { readonly accessorName: "my_level_up_offers" };
    /** @deprecated Use `myPlayerSetting` instead. This alias will be removed in the next major version. */
    readonly "my_player_setting": Omit<typeof tablesSchema.schemaType.tables["myPlayerSetting"], "accessorName"> & { readonly accessorName: "my_player_setting" };
    /** @deprecated Use `myTrades` instead. This alias will be removed in the next major version. */
    readonly "my_trades": Omit<typeof tablesSchema.schemaType.tables["myTrades"], "accessorName"> & { readonly accessorName: "my_trades" };
    /** @deprecated Use `myVillageKnown` instead. This alias will be removed in the next major version. */
    readonly "my_village_known": Omit<typeof tablesSchema.schemaType.tables["myVillageKnown"], "accessorName"> & { readonly accessorName: "my_village_known" };
    /** @deprecated Use `myWorldInvites` instead. This alias will be removed in the next major version. */
    readonly "my_world_invites": Omit<typeof tablesSchema.schemaType.tables["myWorldInvites"], "accessorName"> & { readonly accessorName: "my_world_invites" };
    /** @deprecated Use `myWorldMessages` instead. This alias will be removed in the next major version. */
    readonly "my_world_messages": Omit<typeof tablesSchema.schemaType.tables["myWorldMessages"], "accessorName"> & { readonly accessorName: "my_world_messages" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.13.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "adventure_instance": "adventureInstance",
  "band_call": "bandCall",
  "board_ping": "boardPing",
  "book_chapter": "bookChapter",
  "campaign_progress": "campaignProgress",
  "chronicle_event": "chronicleEvent",
  "chronicle_voice": "chronicleVoice",
  "client_compat": "clientCompat",
  "control_grant": "controlGrant",
  "crawl_force": "crawlForce",
  "dice_table": "diceTable",
  "encounter_boon": "encounterBoon",
  "encounter_haul": "encounterHaul",
  "encounter_result": "encounterResult",
  "encounter_secured": "encounterSecured",
  "encounter_stage": "encounterStage",
  "finish_vote": "finishVote",
  "foe_fate": "foeFate",
  "founding_kit": "foundingKit",
  "founding_market": "foundingMarket",
  "founding_outfit": "foundingOutfit",
  "founding_purse": "foundingPurse",
  "frozen_instance": "frozenInstance",
  "gear_plan": "gearPlan",
  "generation_job": "generationJob",
  "haul_gold": "haulGold",
  "haul_item": "haulItem",
  "hero_boon": "heroBoon",
  "hero_calling": "heroCalling",
  "hero_dye": "heroDye",
  "hero_emote": "heroEmote",
  "hero_meal": "heroMeal",
  "hero_origin": "heroOrigin",
  "hero_pack": "heroPack",
  "hero_progress": "heroProgress",
  "hero_route": "heroRoute",
  "hero_voice": "heroVoice",
  "inn_cheer": "innCheer",
  "inn_guestbook": "innGuestbook",
  "inn_notice": "innNotice",
  "inn_rent": "innRent",
  "inn_song": "innSong",
  "inn_visit": "innVisit",
  "item_dye": "itemDye",
  "item_upgrade": "itemUpgrade",
  "level_up_offer": "levelUpOffer",
  "lobby_seat": "lobbySeat",
  "location_status": "locationStatus",
  "loot_draw": "lootDraw",
  "named_character": "namedCharacter",
  "party_member": "partyMember",
  "party_message": "partyMessage",
  "party_walk": "partyWalk",
  "pause_state": "pauseState",
  "player_colour": "playerColour",
  "player_profile": "playerProfile",
  "puzzle_note": "puzzleNote",
  "puzzle_room": "puzzleRoom",
  "quest_ping": "questPing",
  "quest_stage": "questStage",
  "quest_wound": "questWound",
  "ready_state": "readyState",
  "regard_row": "regardRow",
  "relic_name": "relicName",
  "resolution_log": "resolutionLog",
  "reward_division": "rewardDivision",
  "reward_lock": "rewardLock",
  "reward_pile": "rewardPile",
  "service_identity": "serviceIdentity",
  "sfx_score": "sfxScore",
  "shelf_world": "shelfWorld",
  "spoils_skim": "spoilsSkim",
  "upgrade_gift": "upgradeGift",
  "village_figures": "villageFigures",
  "village_moment": "villageMoment",
  "village_npc": "villageNpc",
  "village_presence": "villagePresence",
  "village_seat": "villageSeat",
  "village_stock": "villageStock",
  "village_workshop": "villageWorkshop",
  "wonder_blessing": "wonderBlessing",
  "world_clock": "worldClock",
  "world_member": "worldMember",
  "world_opening": "worldOpening",
  "world_ping": "worldPing",
  "world_presence": "worldPresence",
  "world_settings": "worldSettings",
  "world_story": "worldStory",
  "my_account": "myAccount",
  "my_collected_pieces": "myCollectedPieces",
  "my_friendships": "myFriendships",
  "my_heroes": "myHeroes",
  "my_inventory": "myInventory",
  "my_level_up_offers": "myLevelUpOffers",
  "my_player_setting": "myPlayerSetting",
  "my_trades": "myTrades",
  "my_village_known": "myVillageKnown",
  "my_world_invites": "myWorldInvites",
  "my_world_messages": "myWorldMessages",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `adventureInstance` instead. This alias will be removed in the next major version. */
  readonly "adventure_instance": __DbViewBase["adventureInstance"];
  /** @deprecated Use `bandCall` instead. This alias will be removed in the next major version. */
  readonly "band_call": __DbViewBase["bandCall"];
  /** @deprecated Use `boardPing` instead. This alias will be removed in the next major version. */
  readonly "board_ping": __DbViewBase["boardPing"];
  /** @deprecated Use `bookChapter` instead. This alias will be removed in the next major version. */
  readonly "book_chapter": __DbViewBase["bookChapter"];
  /** @deprecated Use `campaignProgress` instead. This alias will be removed in the next major version. */
  readonly "campaign_progress": __DbViewBase["campaignProgress"];
  /** @deprecated Use `chronicleEvent` instead. This alias will be removed in the next major version. */
  readonly "chronicle_event": __DbViewBase["chronicleEvent"];
  /** @deprecated Use `chronicleVoice` instead. This alias will be removed in the next major version. */
  readonly "chronicle_voice": __DbViewBase["chronicleVoice"];
  /** @deprecated Use `clientCompat` instead. This alias will be removed in the next major version. */
  readonly "client_compat": __DbViewBase["clientCompat"];
  /** @deprecated Use `controlGrant` instead. This alias will be removed in the next major version. */
  readonly "control_grant": __DbViewBase["controlGrant"];
  /** @deprecated Use `crawlForce` instead. This alias will be removed in the next major version. */
  readonly "crawl_force": __DbViewBase["crawlForce"];
  /** @deprecated Use `diceTable` instead. This alias will be removed in the next major version. */
  readonly "dice_table": __DbViewBase["diceTable"];
  /** @deprecated Use `encounterBoon` instead. This alias will be removed in the next major version. */
  readonly "encounter_boon": __DbViewBase["encounterBoon"];
  /** @deprecated Use `encounterHaul` instead. This alias will be removed in the next major version. */
  readonly "encounter_haul": __DbViewBase["encounterHaul"];
  /** @deprecated Use `encounterResult` instead. This alias will be removed in the next major version. */
  readonly "encounter_result": __DbViewBase["encounterResult"];
  /** @deprecated Use `encounterSecured` instead. This alias will be removed in the next major version. */
  readonly "encounter_secured": __DbViewBase["encounterSecured"];
  /** @deprecated Use `encounterStage` instead. This alias will be removed in the next major version. */
  readonly "encounter_stage": __DbViewBase["encounterStage"];
  /** @deprecated Use `finishVote` instead. This alias will be removed in the next major version. */
  readonly "finish_vote": __DbViewBase["finishVote"];
  /** @deprecated Use `foeFate` instead. This alias will be removed in the next major version. */
  readonly "foe_fate": __DbViewBase["foeFate"];
  /** @deprecated Use `foundingKit` instead. This alias will be removed in the next major version. */
  readonly "founding_kit": __DbViewBase["foundingKit"];
  /** @deprecated Use `foundingMarket` instead. This alias will be removed in the next major version. */
  readonly "founding_market": __DbViewBase["foundingMarket"];
  /** @deprecated Use `foundingOutfit` instead. This alias will be removed in the next major version. */
  readonly "founding_outfit": __DbViewBase["foundingOutfit"];
  /** @deprecated Use `foundingPurse` instead. This alias will be removed in the next major version. */
  readonly "founding_purse": __DbViewBase["foundingPurse"];
  /** @deprecated Use `frozenInstance` instead. This alias will be removed in the next major version. */
  readonly "frozen_instance": __DbViewBase["frozenInstance"];
  /** @deprecated Use `gearPlan` instead. This alias will be removed in the next major version. */
  readonly "gear_plan": __DbViewBase["gearPlan"];
  /** @deprecated Use `generationJob` instead. This alias will be removed in the next major version. */
  readonly "generation_job": __DbViewBase["generationJob"];
  /** @deprecated Use `haulGold` instead. This alias will be removed in the next major version. */
  readonly "haul_gold": __DbViewBase["haulGold"];
  /** @deprecated Use `haulItem` instead. This alias will be removed in the next major version. */
  readonly "haul_item": __DbViewBase["haulItem"];
  /** @deprecated Use `heroBoon` instead. This alias will be removed in the next major version. */
  readonly "hero_boon": __DbViewBase["heroBoon"];
  /** @deprecated Use `heroCalling` instead. This alias will be removed in the next major version. */
  readonly "hero_calling": __DbViewBase["heroCalling"];
  /** @deprecated Use `heroDye` instead. This alias will be removed in the next major version. */
  readonly "hero_dye": __DbViewBase["heroDye"];
  /** @deprecated Use `heroEmote` instead. This alias will be removed in the next major version. */
  readonly "hero_emote": __DbViewBase["heroEmote"];
  /** @deprecated Use `heroMeal` instead. This alias will be removed in the next major version. */
  readonly "hero_meal": __DbViewBase["heroMeal"];
  /** @deprecated Use `heroOrigin` instead. This alias will be removed in the next major version. */
  readonly "hero_origin": __DbViewBase["heroOrigin"];
  /** @deprecated Use `heroPack` instead. This alias will be removed in the next major version. */
  readonly "hero_pack": __DbViewBase["heroPack"];
  /** @deprecated Use `heroProgress` instead. This alias will be removed in the next major version. */
  readonly "hero_progress": __DbViewBase["heroProgress"];
  /** @deprecated Use `heroRoute` instead. This alias will be removed in the next major version. */
  readonly "hero_route": __DbViewBase["heroRoute"];
  /** @deprecated Use `heroVoice` instead. This alias will be removed in the next major version. */
  readonly "hero_voice": __DbViewBase["heroVoice"];
  /** @deprecated Use `innCheer` instead. This alias will be removed in the next major version. */
  readonly "inn_cheer": __DbViewBase["innCheer"];
  /** @deprecated Use `innGuestbook` instead. This alias will be removed in the next major version. */
  readonly "inn_guestbook": __DbViewBase["innGuestbook"];
  /** @deprecated Use `innNotice` instead. This alias will be removed in the next major version. */
  readonly "inn_notice": __DbViewBase["innNotice"];
  /** @deprecated Use `innRent` instead. This alias will be removed in the next major version. */
  readonly "inn_rent": __DbViewBase["innRent"];
  /** @deprecated Use `innSong` instead. This alias will be removed in the next major version. */
  readonly "inn_song": __DbViewBase["innSong"];
  /** @deprecated Use `innVisit` instead. This alias will be removed in the next major version. */
  readonly "inn_visit": __DbViewBase["innVisit"];
  /** @deprecated Use `itemDye` instead. This alias will be removed in the next major version. */
  readonly "item_dye": __DbViewBase["itemDye"];
  /** @deprecated Use `itemUpgrade` instead. This alias will be removed in the next major version. */
  readonly "item_upgrade": __DbViewBase["itemUpgrade"];
  /** @deprecated Use `levelUpOffer` instead. This alias will be removed in the next major version. */
  readonly "level_up_offer": __DbViewBase["levelUpOffer"];
  /** @deprecated Use `lobbySeat` instead. This alias will be removed in the next major version. */
  readonly "lobby_seat": __DbViewBase["lobbySeat"];
  /** @deprecated Use `locationStatus` instead. This alias will be removed in the next major version. */
  readonly "location_status": __DbViewBase["locationStatus"];
  /** @deprecated Use `lootDraw` instead. This alias will be removed in the next major version. */
  readonly "loot_draw": __DbViewBase["lootDraw"];
  /** @deprecated Use `namedCharacter` instead. This alias will be removed in the next major version. */
  readonly "named_character": __DbViewBase["namedCharacter"];
  /** @deprecated Use `partyMember` instead. This alias will be removed in the next major version. */
  readonly "party_member": __DbViewBase["partyMember"];
  /** @deprecated Use `partyMessage` instead. This alias will be removed in the next major version. */
  readonly "party_message": __DbViewBase["partyMessage"];
  /** @deprecated Use `partyWalk` instead. This alias will be removed in the next major version. */
  readonly "party_walk": __DbViewBase["partyWalk"];
  /** @deprecated Use `pauseState` instead. This alias will be removed in the next major version. */
  readonly "pause_state": __DbViewBase["pauseState"];
  /** @deprecated Use `playerColour` instead. This alias will be removed in the next major version. */
  readonly "player_colour": __DbViewBase["playerColour"];
  /** @deprecated Use `playerProfile` instead. This alias will be removed in the next major version. */
  readonly "player_profile": __DbViewBase["playerProfile"];
  /** @deprecated Use `puzzleNote` instead. This alias will be removed in the next major version. */
  readonly "puzzle_note": __DbViewBase["puzzleNote"];
  /** @deprecated Use `puzzleRoom` instead. This alias will be removed in the next major version. */
  readonly "puzzle_room": __DbViewBase["puzzleRoom"];
  /** @deprecated Use `questPing` instead. This alias will be removed in the next major version. */
  readonly "quest_ping": __DbViewBase["questPing"];
  /** @deprecated Use `questStage` instead. This alias will be removed in the next major version. */
  readonly "quest_stage": __DbViewBase["questStage"];
  /** @deprecated Use `questWound` instead. This alias will be removed in the next major version. */
  readonly "quest_wound": __DbViewBase["questWound"];
  /** @deprecated Use `readyState` instead. This alias will be removed in the next major version. */
  readonly "ready_state": __DbViewBase["readyState"];
  /** @deprecated Use `regardRow` instead. This alias will be removed in the next major version. */
  readonly "regard_row": __DbViewBase["regardRow"];
  /** @deprecated Use `relicName` instead. This alias will be removed in the next major version. */
  readonly "relic_name": __DbViewBase["relicName"];
  /** @deprecated Use `resolutionLog` instead. This alias will be removed in the next major version. */
  readonly "resolution_log": __DbViewBase["resolutionLog"];
  /** @deprecated Use `rewardDivision` instead. This alias will be removed in the next major version. */
  readonly "reward_division": __DbViewBase["rewardDivision"];
  /** @deprecated Use `rewardLock` instead. This alias will be removed in the next major version. */
  readonly "reward_lock": __DbViewBase["rewardLock"];
  /** @deprecated Use `rewardPile` instead. This alias will be removed in the next major version. */
  readonly "reward_pile": __DbViewBase["rewardPile"];
  /** @deprecated Use `serviceIdentity` instead. This alias will be removed in the next major version. */
  readonly "service_identity": __DbViewBase["serviceIdentity"];
  /** @deprecated Use `sfxScore` instead. This alias will be removed in the next major version. */
  readonly "sfx_score": __DbViewBase["sfxScore"];
  /** @deprecated Use `shelfWorld` instead. This alias will be removed in the next major version. */
  readonly "shelf_world": __DbViewBase["shelfWorld"];
  /** @deprecated Use `spoilsSkim` instead. This alias will be removed in the next major version. */
  readonly "spoils_skim": __DbViewBase["spoilsSkim"];
  /** @deprecated Use `upgradeGift` instead. This alias will be removed in the next major version. */
  readonly "upgrade_gift": __DbViewBase["upgradeGift"];
  /** @deprecated Use `villageFigures` instead. This alias will be removed in the next major version. */
  readonly "village_figures": __DbViewBase["villageFigures"];
  /** @deprecated Use `villageMoment` instead. This alias will be removed in the next major version. */
  readonly "village_moment": __DbViewBase["villageMoment"];
  /** @deprecated Use `villageNpc` instead. This alias will be removed in the next major version. */
  readonly "village_npc": __DbViewBase["villageNpc"];
  /** @deprecated Use `villagePresence` instead. This alias will be removed in the next major version. */
  readonly "village_presence": __DbViewBase["villagePresence"];
  /** @deprecated Use `villageSeat` instead. This alias will be removed in the next major version. */
  readonly "village_seat": __DbViewBase["villageSeat"];
  /** @deprecated Use `villageStock` instead. This alias will be removed in the next major version. */
  readonly "village_stock": __DbViewBase["villageStock"];
  /** @deprecated Use `villageWorkshop` instead. This alias will be removed in the next major version. */
  readonly "village_workshop": __DbViewBase["villageWorkshop"];
  /** @deprecated Use `wonderBlessing` instead. This alias will be removed in the next major version. */
  readonly "wonder_blessing": __DbViewBase["wonderBlessing"];
  /** @deprecated Use `worldClock` instead. This alias will be removed in the next major version. */
  readonly "world_clock": __DbViewBase["worldClock"];
  /** @deprecated Use `worldMember` instead. This alias will be removed in the next major version. */
  readonly "world_member": __DbViewBase["worldMember"];
  /** @deprecated Use `worldOpening` instead. This alias will be removed in the next major version. */
  readonly "world_opening": __DbViewBase["worldOpening"];
  /** @deprecated Use `worldPing` instead. This alias will be removed in the next major version. */
  readonly "world_ping": __DbViewBase["worldPing"];
  /** @deprecated Use `worldPresence` instead. This alias will be removed in the next major version. */
  readonly "world_presence": __DbViewBase["worldPresence"];
  /** @deprecated Use `worldSettings` instead. This alias will be removed in the next major version. */
  readonly "world_settings": __DbViewBase["worldSettings"];
  /** @deprecated Use `worldStory` instead. This alias will be removed in the next major version. */
  readonly "world_story": __DbViewBase["worldStory"];
  /** @deprecated Use `myAccount` instead. This alias will be removed in the next major version. */
  readonly "my_account": __DbViewBase["myAccount"];
  /** @deprecated Use `myCollectedPieces` instead. This alias will be removed in the next major version. */
  readonly "my_collected_pieces": __DbViewBase["myCollectedPieces"];
  /** @deprecated Use `myFriendships` instead. This alias will be removed in the next major version. */
  readonly "my_friendships": __DbViewBase["myFriendships"];
  /** @deprecated Use `myHeroes` instead. This alias will be removed in the next major version. */
  readonly "my_heroes": __DbViewBase["myHeroes"];
  /** @deprecated Use `myInventory` instead. This alias will be removed in the next major version. */
  readonly "my_inventory": __DbViewBase["myInventory"];
  /** @deprecated Use `myLevelUpOffers` instead. This alias will be removed in the next major version. */
  readonly "my_level_up_offers": __DbViewBase["myLevelUpOffers"];
  /** @deprecated Use `myPlayerSetting` instead. This alias will be removed in the next major version. */
  readonly "my_player_setting": __DbViewBase["myPlayerSetting"];
  /** @deprecated Use `myTrades` instead. This alias will be removed in the next major version. */
  readonly "my_trades": __DbViewBase["myTrades"];
  /** @deprecated Use `myVillageKnown` instead. This alias will be removed in the next major version. */
  readonly "my_village_known": __DbViewBase["myVillageKnown"];
  /** @deprecated Use `myWorldInvites` instead. This alias will be removed in the next major version. */
  readonly "my_world_invites": __DbViewBase["myWorldInvites"];
  /** @deprecated Use `myWorldMessages` instead. This alias will be removed in the next major version. */
  readonly "my_world_messages": __DbViewBase["myWorldMessages"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `adventureInstance` instead. This alias will be removed in the next major version. */
  readonly "adventure_instance": __TablesBase["adventureInstance"];
  /** @deprecated Use `bandCall` instead. This alias will be removed in the next major version. */
  readonly "band_call": __TablesBase["bandCall"];
  /** @deprecated Use `boardPing` instead. This alias will be removed in the next major version. */
  readonly "board_ping": __TablesBase["boardPing"];
  /** @deprecated Use `bookChapter` instead. This alias will be removed in the next major version. */
  readonly "book_chapter": __TablesBase["bookChapter"];
  /** @deprecated Use `campaignProgress` instead. This alias will be removed in the next major version. */
  readonly "campaign_progress": __TablesBase["campaignProgress"];
  /** @deprecated Use `chronicleEvent` instead. This alias will be removed in the next major version. */
  readonly "chronicle_event": __TablesBase["chronicleEvent"];
  /** @deprecated Use `chronicleVoice` instead. This alias will be removed in the next major version. */
  readonly "chronicle_voice": __TablesBase["chronicleVoice"];
  /** @deprecated Use `clientCompat` instead. This alias will be removed in the next major version. */
  readonly "client_compat": __TablesBase["clientCompat"];
  /** @deprecated Use `controlGrant` instead. This alias will be removed in the next major version. */
  readonly "control_grant": __TablesBase["controlGrant"];
  /** @deprecated Use `crawlForce` instead. This alias will be removed in the next major version. */
  readonly "crawl_force": __TablesBase["crawlForce"];
  /** @deprecated Use `diceTable` instead. This alias will be removed in the next major version. */
  readonly "dice_table": __TablesBase["diceTable"];
  /** @deprecated Use `encounterBoon` instead. This alias will be removed in the next major version. */
  readonly "encounter_boon": __TablesBase["encounterBoon"];
  /** @deprecated Use `encounterHaul` instead. This alias will be removed in the next major version. */
  readonly "encounter_haul": __TablesBase["encounterHaul"];
  /** @deprecated Use `encounterResult` instead. This alias will be removed in the next major version. */
  readonly "encounter_result": __TablesBase["encounterResult"];
  /** @deprecated Use `encounterSecured` instead. This alias will be removed in the next major version. */
  readonly "encounter_secured": __TablesBase["encounterSecured"];
  /** @deprecated Use `encounterStage` instead. This alias will be removed in the next major version. */
  readonly "encounter_stage": __TablesBase["encounterStage"];
  /** @deprecated Use `finishVote` instead. This alias will be removed in the next major version. */
  readonly "finish_vote": __TablesBase["finishVote"];
  /** @deprecated Use `foeFate` instead. This alias will be removed in the next major version. */
  readonly "foe_fate": __TablesBase["foeFate"];
  /** @deprecated Use `foundingKit` instead. This alias will be removed in the next major version. */
  readonly "founding_kit": __TablesBase["foundingKit"];
  /** @deprecated Use `foundingMarket` instead. This alias will be removed in the next major version. */
  readonly "founding_market": __TablesBase["foundingMarket"];
  /** @deprecated Use `foundingOutfit` instead. This alias will be removed in the next major version. */
  readonly "founding_outfit": __TablesBase["foundingOutfit"];
  /** @deprecated Use `foundingPurse` instead. This alias will be removed in the next major version. */
  readonly "founding_purse": __TablesBase["foundingPurse"];
  /** @deprecated Use `frozenInstance` instead. This alias will be removed in the next major version. */
  readonly "frozen_instance": __TablesBase["frozenInstance"];
  /** @deprecated Use `gearPlan` instead. This alias will be removed in the next major version. */
  readonly "gear_plan": __TablesBase["gearPlan"];
  /** @deprecated Use `generationJob` instead. This alias will be removed in the next major version. */
  readonly "generation_job": __TablesBase["generationJob"];
  /** @deprecated Use `haulGold` instead. This alias will be removed in the next major version. */
  readonly "haul_gold": __TablesBase["haulGold"];
  /** @deprecated Use `haulItem` instead. This alias will be removed in the next major version. */
  readonly "haul_item": __TablesBase["haulItem"];
  /** @deprecated Use `heroBoon` instead. This alias will be removed in the next major version. */
  readonly "hero_boon": __TablesBase["heroBoon"];
  /** @deprecated Use `heroCalling` instead. This alias will be removed in the next major version. */
  readonly "hero_calling": __TablesBase["heroCalling"];
  /** @deprecated Use `heroDye` instead. This alias will be removed in the next major version. */
  readonly "hero_dye": __TablesBase["heroDye"];
  /** @deprecated Use `heroEmote` instead. This alias will be removed in the next major version. */
  readonly "hero_emote": __TablesBase["heroEmote"];
  /** @deprecated Use `heroMeal` instead. This alias will be removed in the next major version. */
  readonly "hero_meal": __TablesBase["heroMeal"];
  /** @deprecated Use `heroOrigin` instead. This alias will be removed in the next major version. */
  readonly "hero_origin": __TablesBase["heroOrigin"];
  /** @deprecated Use `heroPack` instead. This alias will be removed in the next major version. */
  readonly "hero_pack": __TablesBase["heroPack"];
  /** @deprecated Use `heroProgress` instead. This alias will be removed in the next major version. */
  readonly "hero_progress": __TablesBase["heroProgress"];
  /** @deprecated Use `heroRoute` instead. This alias will be removed in the next major version. */
  readonly "hero_route": __TablesBase["heroRoute"];
  /** @deprecated Use `heroVoice` instead. This alias will be removed in the next major version. */
  readonly "hero_voice": __TablesBase["heroVoice"];
  /** @deprecated Use `innCheer` instead. This alias will be removed in the next major version. */
  readonly "inn_cheer": __TablesBase["innCheer"];
  /** @deprecated Use `innGuestbook` instead. This alias will be removed in the next major version. */
  readonly "inn_guestbook": __TablesBase["innGuestbook"];
  /** @deprecated Use `innNotice` instead. This alias will be removed in the next major version. */
  readonly "inn_notice": __TablesBase["innNotice"];
  /** @deprecated Use `innRent` instead. This alias will be removed in the next major version. */
  readonly "inn_rent": __TablesBase["innRent"];
  /** @deprecated Use `innSong` instead. This alias will be removed in the next major version. */
  readonly "inn_song": __TablesBase["innSong"];
  /** @deprecated Use `innVisit` instead. This alias will be removed in the next major version. */
  readonly "inn_visit": __TablesBase["innVisit"];
  /** @deprecated Use `itemDye` instead. This alias will be removed in the next major version. */
  readonly "item_dye": __TablesBase["itemDye"];
  /** @deprecated Use `itemUpgrade` instead. This alias will be removed in the next major version. */
  readonly "item_upgrade": __TablesBase["itemUpgrade"];
  /** @deprecated Use `levelUpOffer` instead. This alias will be removed in the next major version. */
  readonly "level_up_offer": __TablesBase["levelUpOffer"];
  /** @deprecated Use `lobbySeat` instead. This alias will be removed in the next major version. */
  readonly "lobby_seat": __TablesBase["lobbySeat"];
  /** @deprecated Use `locationStatus` instead. This alias will be removed in the next major version. */
  readonly "location_status": __TablesBase["locationStatus"];
  /** @deprecated Use `lootDraw` instead. This alias will be removed in the next major version. */
  readonly "loot_draw": __TablesBase["lootDraw"];
  /** @deprecated Use `namedCharacter` instead. This alias will be removed in the next major version. */
  readonly "named_character": __TablesBase["namedCharacter"];
  /** @deprecated Use `partyMember` instead. This alias will be removed in the next major version. */
  readonly "party_member": __TablesBase["partyMember"];
  /** @deprecated Use `partyMessage` instead. This alias will be removed in the next major version. */
  readonly "party_message": __TablesBase["partyMessage"];
  /** @deprecated Use `partyWalk` instead. This alias will be removed in the next major version. */
  readonly "party_walk": __TablesBase["partyWalk"];
  /** @deprecated Use `pauseState` instead. This alias will be removed in the next major version. */
  readonly "pause_state": __TablesBase["pauseState"];
  /** @deprecated Use `playerColour` instead. This alias will be removed in the next major version. */
  readonly "player_colour": __TablesBase["playerColour"];
  /** @deprecated Use `playerProfile` instead. This alias will be removed in the next major version. */
  readonly "player_profile": __TablesBase["playerProfile"];
  /** @deprecated Use `puzzleNote` instead. This alias will be removed in the next major version. */
  readonly "puzzle_note": __TablesBase["puzzleNote"];
  /** @deprecated Use `puzzleRoom` instead. This alias will be removed in the next major version. */
  readonly "puzzle_room": __TablesBase["puzzleRoom"];
  /** @deprecated Use `questPing` instead. This alias will be removed in the next major version. */
  readonly "quest_ping": __TablesBase["questPing"];
  /** @deprecated Use `questStage` instead. This alias will be removed in the next major version. */
  readonly "quest_stage": __TablesBase["questStage"];
  /** @deprecated Use `questWound` instead. This alias will be removed in the next major version. */
  readonly "quest_wound": __TablesBase["questWound"];
  /** @deprecated Use `readyState` instead. This alias will be removed in the next major version. */
  readonly "ready_state": __TablesBase["readyState"];
  /** @deprecated Use `regardRow` instead. This alias will be removed in the next major version. */
  readonly "regard_row": __TablesBase["regardRow"];
  /** @deprecated Use `relicName` instead. This alias will be removed in the next major version. */
  readonly "relic_name": __TablesBase["relicName"];
  /** @deprecated Use `resolutionLog` instead. This alias will be removed in the next major version. */
  readonly "resolution_log": __TablesBase["resolutionLog"];
  /** @deprecated Use `rewardDivision` instead. This alias will be removed in the next major version. */
  readonly "reward_division": __TablesBase["rewardDivision"];
  /** @deprecated Use `rewardLock` instead. This alias will be removed in the next major version. */
  readonly "reward_lock": __TablesBase["rewardLock"];
  /** @deprecated Use `rewardPile` instead. This alias will be removed in the next major version. */
  readonly "reward_pile": __TablesBase["rewardPile"];
  /** @deprecated Use `serviceIdentity` instead. This alias will be removed in the next major version. */
  readonly "service_identity": __TablesBase["serviceIdentity"];
  /** @deprecated Use `sfxScore` instead. This alias will be removed in the next major version. */
  readonly "sfx_score": __TablesBase["sfxScore"];
  /** @deprecated Use `shelfWorld` instead. This alias will be removed in the next major version. */
  readonly "shelf_world": __TablesBase["shelfWorld"];
  /** @deprecated Use `spoilsSkim` instead. This alias will be removed in the next major version. */
  readonly "spoils_skim": __TablesBase["spoilsSkim"];
  /** @deprecated Use `upgradeGift` instead. This alias will be removed in the next major version. */
  readonly "upgrade_gift": __TablesBase["upgradeGift"];
  /** @deprecated Use `villageFigures` instead. This alias will be removed in the next major version. */
  readonly "village_figures": __TablesBase["villageFigures"];
  /** @deprecated Use `villageMoment` instead. This alias will be removed in the next major version. */
  readonly "village_moment": __TablesBase["villageMoment"];
  /** @deprecated Use `villageNpc` instead. This alias will be removed in the next major version. */
  readonly "village_npc": __TablesBase["villageNpc"];
  /** @deprecated Use `villagePresence` instead. This alias will be removed in the next major version. */
  readonly "village_presence": __TablesBase["villagePresence"];
  /** @deprecated Use `villageSeat` instead. This alias will be removed in the next major version. */
  readonly "village_seat": __TablesBase["villageSeat"];
  /** @deprecated Use `villageStock` instead. This alias will be removed in the next major version. */
  readonly "village_stock": __TablesBase["villageStock"];
  /** @deprecated Use `villageWorkshop` instead. This alias will be removed in the next major version. */
  readonly "village_workshop": __TablesBase["villageWorkshop"];
  /** @deprecated Use `wonderBlessing` instead. This alias will be removed in the next major version. */
  readonly "wonder_blessing": __TablesBase["wonderBlessing"];
  /** @deprecated Use `worldClock` instead. This alias will be removed in the next major version. */
  readonly "world_clock": __TablesBase["worldClock"];
  /** @deprecated Use `worldMember` instead. This alias will be removed in the next major version. */
  readonly "world_member": __TablesBase["worldMember"];
  /** @deprecated Use `worldOpening` instead. This alias will be removed in the next major version. */
  readonly "world_opening": __TablesBase["worldOpening"];
  /** @deprecated Use `worldPing` instead. This alias will be removed in the next major version. */
  readonly "world_ping": __TablesBase["worldPing"];
  /** @deprecated Use `worldPresence` instead. This alias will be removed in the next major version. */
  readonly "world_presence": __TablesBase["worldPresence"];
  /** @deprecated Use `worldSettings` instead. This alias will be removed in the next major version. */
  readonly "world_settings": __TablesBase["worldSettings"];
  /** @deprecated Use `worldStory` instead. This alias will be removed in the next major version. */
  readonly "world_story": __TablesBase["worldStory"];
  /** @deprecated Use `myAccount` instead. This alias will be removed in the next major version. */
  readonly "my_account": __TablesBase["myAccount"];
  /** @deprecated Use `myCollectedPieces` instead. This alias will be removed in the next major version. */
  readonly "my_collected_pieces": __TablesBase["myCollectedPieces"];
  /** @deprecated Use `myFriendships` instead. This alias will be removed in the next major version. */
  readonly "my_friendships": __TablesBase["myFriendships"];
  /** @deprecated Use `myHeroes` instead. This alias will be removed in the next major version. */
  readonly "my_heroes": __TablesBase["myHeroes"];
  /** @deprecated Use `myInventory` instead. This alias will be removed in the next major version. */
  readonly "my_inventory": __TablesBase["myInventory"];
  /** @deprecated Use `myLevelUpOffers` instead. This alias will be removed in the next major version. */
  readonly "my_level_up_offers": __TablesBase["myLevelUpOffers"];
  /** @deprecated Use `myPlayerSetting` instead. This alias will be removed in the next major version. */
  readonly "my_player_setting": __TablesBase["myPlayerSetting"];
  /** @deprecated Use `myTrades` instead. This alias will be removed in the next major version. */
  readonly "my_trades": __TablesBase["myTrades"];
  /** @deprecated Use `myVillageKnown` instead. This alias will be removed in the next major version. */
  readonly "my_village_known": __TablesBase["myVillageKnown"];
  /** @deprecated Use `myWorldInvites` instead. This alias will be removed in the next major version. */
  readonly "my_world_invites": __TablesBase["myWorldInvites"];
  /** @deprecated Use `myWorldMessages` instead. This alias will be removed in the next major version. */
  readonly "my_world_messages": __TablesBase["myWorldMessages"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

